(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greamwar-documentation"] && !Shopify.designMode) return;
  try {
    
  const initializeGreamwarDocumentation = (root) => {
    const cleanDocumentationUrl = () => {
      if (location.pathname !== '/docs' || location.search || location.hash) {
        history.replaceState({ ...history.state, greamhubDoc: true }, '', '/docs');
      }
    };
    const findHashTarget = (hash) => {
      if (!hash || hash === '#') return null;
      try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
      catch (_) { return null; }
    };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const initialHash = location.hash;
    const initialTarget = findHashTarget(initialHash);
    if (initialTarget) {
      initialTarget.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    cleanDocumentationUrl();

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.dataset.gwDocAnchorBound === 'true') return;
      link.dataset.gwDocAnchorBound = 'true';
      link.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const hash = link.getAttribute('href');
        const target = findHashTarget(hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        const mobileContents = link.closest('.gw-doc-page__mobile-toc');
        if (mobileContents) mobileContents.removeAttribute('open');
        cleanDocumentationUrl();
      });
    });

    const panelRoute = root.querySelector('[data-gw-panel-route]');
    if (panelRoute && panelRoute.dataset.gwPanelRouteBound !== 'true') {
      panelRoute.dataset.gwPanelRouteBound = 'true';
      panelRoute.addEventListener('click', () => {
        try { window.sessionStorage.setItem('greamwar-panel-menu-request', String(Date.now())); } catch (_) {}
      });
    }
    const revealItems = Array.from(root.querySelectorAll('[data-gw-doc-reveal]'));
    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('gw-doc-page__visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gw-doc-page__visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealItems.forEach((item) => observer.observe(item));
  };

  document.querySelectorAll('[data-gw-doc-page]').forEach(initializeGreamwarDocumentation);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-gw-doc-page]');
    if (root) initializeGreamwarDocumentation(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["greamwar-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-gw-home] a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('data-gw-panel')) {
      const launcher = document.querySelector('[data-purchase-panel-open]');
      if (launcher) {
        event.preventDefault();
        launcher.click();
      }
    } else {
      const href = link.getAttribute('href');
      const target = href?.startsWith('#') ? document.getElementById(href.slice(1)) : null;
      if (target) {
        event.preventDefault();
        window.history.replaceState({ greamwarSection: href }, '', '/');
        target.scrollIntoView({
          behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    }
    if (link.hasAttribute('data-gw-policies')) {
      const resource = document.querySelector('details[id^="FooterPolicies-"]');
      if (resource) {
        resource.open = true;
        resource.querySelector('summary')?.focus({ preventScroll: true });
      }
    }
  });

  const createGreamwarMotion = (root) => {
    const hero = root.querySelector('.gw-home__hero');
    const stage = root.querySelector('.gw-home__hero-stage');
    const logo = root.querySelector('.gw-home__logo-scene');
    if (!hero || !stage || !logo || root.dataset.gwMotion === 'off') return () => {};
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let stop = () => {};
    const changeMotion = () => {
      stop();
      if (media.matches) return;
      let frame = 0;
      let stopped = false;
      const properties = ['--gw-logo-y', '--gw-logo-scale', '--gw-hero-opacity', '--gw-hero-y', '--gw-cue-opacity'];
      const reveals = Array.from(root.querySelectorAll('[data-gw-reveal]'));
      const disclosures = new Map();
      let revealObserver;
      let heroObserver;
      const clamp = (number) => Math.max(0, Math.min(1, number));
      const ease = (number) => number * number * (3 - 2 * number);
      const update = () => {
        frame = 0;
        if (stopped || document.hidden) return;
        const rect = hero.getBoundingClientRect();
        const progress = clamp(-rect.top / Math.max(1, hero.offsetHeight - stage.offsetHeight));
        const entrance = ease(clamp(progress / .42));
        const exit = ease(clamp((progress - .70) / .30));
        const values = [
          `${(-70 * entrance).toFixed(2)}px`,
          (1.20 - entrance * .29).toFixed(4),
          (1 - exit).toFixed(4), `${(-90 * exit).toFixed(2)}px`,
          (1 - ease(clamp(progress / .32))).toFixed(4)
        ];
        properties.forEach((property, index) => root.style.setProperty(property, values[index]));
      };
      const schedule = () => {
        if (!frame && !stopped && !document.hidden) frame = window.requestAnimationFrame(update);
      };
      const visibility = () => {
        root.classList.toggle('gw-home--paused', document.hidden);
        if (document.hidden && frame) { window.cancelAnimationFrame(frame); frame = 0; }
        if (!document.hidden) schedule();
      };
      const showFocused = (event) => {
        const target = event.target.closest('[data-gw-reveal-ready]');
        if (target && root.contains(target)) {
          target.classList.add('gw-is-visible');
          revealObserver?.unobserve(target);
        }
      };
      const finishDisclosure = (detail, state) => {
        if (disclosures.get(detail) !== state) return;
        disclosures.delete(detail);
        detail.open = state.open;
        detail.style.overflow = '';
        if (state.animation) { state.animation.onfinish = null; state.animation.cancel(); }
        state.textAnimation?.cancel();
        schedule();
      };
      const disclosureClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || !(event.target instanceof Element)) return;
        const summary = event.target.closest('.gw-home__question > summary');
        if (!summary || !root.contains(summary)) return;
        const detail = summary.parentElement;
        if (typeof detail.animate !== 'function') return;
        event.preventDefault();
        const previous = disclosures.get(detail);
        const open = previous ? !previous.open : !detail.open;
        const start = detail.getBoundingClientRect().height;
        if (previous) {
          previous.animation.onfinish = null;
          previous.animation.cancel();
          previous.textAnimation?.cancel();
        }
        detail.open = true;
        const end = open ? detail.getBoundingClientRect().height : summary.getBoundingClientRect().height + 1;
        detail.style.overflow = 'hidden';
        const state = { open, animation: null, textAnimation: null };
        disclosures.set(detail, state);
        try {
          state.animation = detail.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 400, easing: 'cubic-bezier(.16, 1, .3, 1)' });
          const text = detail.querySelector('p');
          if (text?.animate) state.textAnimation = text.animate([{ opacity: open ? 0 : 1, transform: open ? 'translateY(-10px)' : 'translateY(0)' }, { opacity: open ? 1 : 0, transform: open ? 'translateY(0)' : 'translateY(-10px)' }], { duration: 400, easing: 'cubic-bezier(.16, 1, .3, 1)' });
          state.animation.onfinish = () => finishDisclosure(detail, state);
        } catch { finishDisclosure(detail, state); }
      };
      root.classList.add('gw-home--motion');
      update();
      if ('IntersectionObserver' in window) {
        revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('gw-is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: .08, rootMargin: '0px 0px -36px 0px' });
        reveals.forEach((element) => { element.setAttribute('data-gw-reveal-ready', ''); revealObserver.observe(element); });
        heroObserver = new IntersectionObserver((entries) => {
          root.classList.toggle('gw-home--hero-away', !entries[0].isIntersecting);
        });
        heroObserver.observe(hero);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
      document.addEventListener('visibilitychange', visibility);
      root.addEventListener('focusin', showFocused);
      root.addEventListener('click', disclosureClick);
      visibility();
      stop = () => {
        stopped = true;
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        revealObserver?.disconnect();
        heroObserver?.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('pageshow', schedule);
        document.removeEventListener('visibilitychange', visibility);
        root.removeEventListener('focusin', showFocused);
        root.removeEventListener('click', disclosureClick);
        disclosures.forEach((state, detail) => finishDisclosure(detail, state));
        root.classList.remove('gw-home--motion', 'gw-home--paused', 'gw-home--hero-away');
        properties.forEach((property) => root.style.removeProperty(property));
        reveals.forEach((element) => { element.removeAttribute('data-gw-reveal-ready'); element.classList.remove('gw-is-visible'); });
      };
    };
    media.addEventListener('change', changeMotion);
    changeMotion();
    return () => { stop(); media.removeEventListener('change', changeMotion); };
  };

  const createGreamwarNavigation = (root) => {
    const nav = root.querySelector('.gw-home__nav');
    if (!nav) return () => {};
    const rootPath = '/';
    const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
    const sectionHref = (link) => link.dataset.gwSection || link.getAttribute('href');
    const links = Array.from(nav.querySelectorAll('a[data-gw-section], a[href^="#"]'));
    const legacyHash = window.location.hash;
    const fragment = new URLSearchParams(legacyHash.replace(/^#/, ''));
    const isDiscordCallback = fragment.has('access_token') || fragment.has('error');
    const isPanelRoute = normalizePath(window.location.pathname) === '/panel'
      || new URLSearchParams(window.location.search).get('panel') === 'greamwar';
    const panelIsOpen = document.body.classList.contains('purchase-panel-open');
    if (!panelIsOpen && !isPanelRoute && !isDiscordCallback
        && (normalizePath(window.location.pathname) !== rootPath || window.location.search || legacyHash)) {
      window.history.replaceState({ greamwarSection: legacyHash || '#greamwar-home' }, '', rootPath);
    }
    if (legacyHash === '#greamwar-access' || legacyHash === '#greamwar-home') {
      window.requestAnimationFrame(() => {
        document.getElementById(legacyHash.slice(1))?.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    }
    let frame = 0;
    let stopped = false;
    let current = null;
    let navigationIntent = null;
    const clearIntent = () => {
      if (!navigationIntent) return;
      window.clearTimeout(navigationIntent.settleTimer);
      window.clearTimeout(navigationIntent.deadlineTimer);
      navigationIntent = null;
    };
    const select = (href) => {
      if (current === href) return;
      current = href;
      links.forEach((link) => {
        if (sectionHref(link) === href) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const update = () => {
      frame = 0;
      if (stopped || document.hidden) return;
      if (document.body.classList.contains('purchase-panel-open')) { clearIntent(); select('#purchase'); return; }
      if (navigationIntent) { select(navigationIntent.href); return; }
      const marker = Math.min(window.innerHeight * .4, Math.max(150, nav.getBoundingClientRect().bottom + 32));
      const atBottom = window.scrollY > 0 && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 3;
      let active = '#greamwar-home';
      let nearest = -Infinity;
      links.forEach((link) => {
        const href = sectionHref(link);
        if (href === '#greamwar-home' || href === '#purchase') return;
        const target = document.getElementById(href.slice(1));
        if (!target || !target.getClientRects().length) return;
        const rect = target.getBoundingClientRect();
        if ((rect.top <= marker + 2 || (atBottom && rect.top < window.innerHeight)) && rect.top > nearest) {
          active = href;
          nearest = rect.top;
        }
      });
      select(active);
    };
    const schedule = () => {
      if (!frame && !stopped && !document.hidden) frame = window.requestAnimationFrame(update);
    };
    const finishNavigation = (intent) => {
      if (stopped || navigationIntent !== intent) return;
      clearIntent();
      schedule();
    };
    const settleNavigation = () => {
      const intent = navigationIntent;
      if (!intent) return;
      window.clearTimeout(intent.settleTimer);
      intent.settleTimer = window.setTimeout(() => finishNavigation(intent), 180);
    };
    const scroll = () => {
      settleNavigation();
      schedule();
    };
    const manual = () => {
      clearIntent();
      schedule();
    };
    const handleHistory = (event) => {
      const currentFragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const isDiscordCallback = currentFragment.has('access_token') || currentFragment.has('error');
      const legacyRoute = window.location.hash && !isDiscordCallback ? window.location.hash : null;
      if (legacyRoute) {
        window.history.replaceState({ greamwarSection: legacyRoute }, '', rootPath);
        document.getElementById(legacyRoute.slice(1))?.scrollIntoView({ behavior: 'auto', block: 'start' });
        select(legacyRoute);
        clearIntent();
        schedule();
        return;
      }
      if (event.type === 'popstate') {
        const currentPath = normalizePath(window.location.pathname);
        const route = currentPath === normalizePath(rootPath)
          ? event.state?.greamwarSection || '#greamwar-home'
          : null;
        if (route) {
          document.getElementById(route.slice(1))?.scrollIntoView({ behavior: 'auto', block: 'start' });
          select(route);
        }
      }
      if (navigationIntent && window.location.hash && window.location.hash !== navigationIntent.href) clearIntent();
      schedule();
    };
    const keydown = (event) => {
      if (!['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) return;
      if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable="true"], [role="textbox"]')) return;
      manual();
    };
    const click = (event) => {
      if (document.body.classList.contains('purchase-panel-open')) { clearIntent(); select('#purchase'); return; }
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !(event.target instanceof Element)) return;
      const link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      const href = sectionHref(link);
      if (href === '#purchase' || !links.some((item) => sectionHref(item) === href)) return;
      const target = document.getElementById(href.slice(1));
      if (!target || !target.getClientRects().length) return;
      if (link.dataset.gwSection) {
        event.preventDefault();
        window.history.replaceState({ greamwarSection: href }, '', rootPath);
        target.scrollIntoView({
          behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
      clearIntent();
      const intent = { href, settleTimer: 0, deadlineTimer: 0 };
      navigationIntent = intent;
      select(href);
      settleNavigation();
      intent.deadlineTimer = window.setTimeout(() => finishNavigation(intent), 3000);
    };
    const visibility = () => {
      if (document.hidden) clearIntent();
      if (document.hidden && frame) { window.cancelAnimationFrame(frame); frame = 0; }
      if (!document.hidden) schedule();
    };
    let panelObserver;
    let layoutObserver;
    if ('MutationObserver' in window) {
      panelObserver = new MutationObserver(schedule);
      panelObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    if ('ResizeObserver' in window) {
      layoutObserver = new ResizeObserver(schedule);
      layoutObserver.observe(root);
      layoutObserver.observe(nav);
      const footer = document.querySelector('.site-footer');
      if (footer) layoutObserver.observe(footer);
    }
    window.addEventListener('scroll', scroll, { passive: true });
    window.addEventListener('wheel', manual, { passive: true });
    window.addEventListener('touchstart', manual, { passive: true });
    window.addEventListener('pointerdown', manual, { passive: true });
    window.addEventListener('keydown', keydown);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('hashchange', handleHistory);
    window.addEventListener('popstate', handleHistory);
    window.addEventListener('pageshow', manual);
    document.addEventListener('visibilitychange', visibility);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('click', click);
    update();
    return () => {
      stopped = true;
      clearIntent();
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      panelObserver?.disconnect();
      layoutObserver?.disconnect();
      window.removeEventListener('scroll', scroll);
      window.removeEventListener('wheel', manual);
      window.removeEventListener('touchstart', manual);
      window.removeEventListener('pointerdown', manual);
      window.removeEventListener('keydown', keydown);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('hashchange', handleHistory);
      window.removeEventListener('popstate', handleHistory);
      window.removeEventListener('pageshow', manual);
      document.removeEventListener('visibilitychange', visibility);
      document.removeEventListener('toggle', schedule, true);
      document.removeEventListener('click', click);
    };
  };

  const greamwarMotionControllers = new Map();
  const initializeGreamwarMotion = () => {
    document.querySelectorAll('[data-gw-home]').forEach((root) => {
      if (!greamwarMotionControllers.has(root)) {
        const stopMotion = createGreamwarMotion(root);
        const stopNavigation = createGreamwarNavigation(root);
        greamwarMotionControllers.set(root, () => { stopNavigation(); stopMotion(); });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGreamwarMotion, { once: true });
  else initializeGreamwarMotion();
  document.addEventListener('shopify:section:load', initializeGreamwarMotion);
  document.addEventListener('shopify:section:unload', (event) => {
    greamwarMotionControllers.forEach((destroy, root) => {
      if (event.target.contains(root)) { destroy(); greamwarMotionControllers.delete(root); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  const apiOrigin = 'https://api.lysloader.xyz';
  const endpoint = `${apiOrigin}/discord/messages`;
  const resetEndpoint = `${apiOrigin}/luarmor/reset-hwid`;
  const scriptControlEndpoint = `${apiOrigin}/luarmor/script-control`;
  const redirectUri = 'https://greamhub.com/';
  const storefrontOrigins = ['https://greamhub.com', 'https://www.greamhub.com'];
  const guildId = '1541768230417203320';
  const channelId = '1544368236924239872';
  const roleId = '1544101751760748625';

  const callback = new URLSearchParams(location.hash.replace(/^#/, ''));
  if (callback.has('access_token') || callback.has('error')) {
    const fragment = location.hash;
    history.replaceState({}, '', location.pathname + location.search);
    if (window.opener && storefrontOrigins.includes(location.origin) && fragment.length <= 4096) {
      for (const origin of storefrontOrigins) {
        window.opener.postMessage({ kind: 'greamwar-discord-oauth', fragment }, origin);
      }
      window.close();
      return;
    }
  }

  const createTelemetryView = (document, labels, locale, chevronTemplate, getDiscordUser = () => null, getFallbackLogoUrl = () => '') => {
    const fieldTypes = {
      diamants: 'number', profit_session: 'number', temps_farm: 'text', niveau: 'number',
      diamants_gagnes: 'number', diamants_par_heure: 'number', diamants_gagnes_ici: 'number', diamants_depart: 'number',
      cloud_cash: 'number', cloud_cash_gagne: 'number', cloud_cash_depart: 'number',
      candy: 'number', candy_gagne: 'number',
      niveaux_gagnes: 'number', niveau_depart: 'number',
      joueur: 'text', user_id: 'id', lieu: 'text', place_id: 'id', session: 'text', discord_id: 'discord'
    };
    const aliases = {
      diamants: 'diamonds', temps_farm: 'farm_time', niveau: 'level',
      diamants_gagnes: 'diamonds_earned', diamants_par_heure: 'diamonds_per_hour', diamants_gagnes_ici: 'diamonds_earned_here',
      diamants_depart: 'starting_diamonds', cloud_cash_gagne: 'cloud_cash_earned',
      cloud_cash_depart: 'starting_cloud_cash', niveaux_gagnes: 'levels_gained',
      niveau_depart: 'starting_level', candy_gagne: 'candy_earned',
      joueur: 'player', lieu: 'location', meilleurs_lieux: 'best_locations'
    };
    const inputValue = (input, key) => Object.prototype.hasOwnProperty.call(input, key) ? input[key]
      : aliases[key] && Object.prototype.hasOwnProperty.call(input, aliases[key]) ? input[aliases[key]] : undefined;
    const numeric = new Set(Object.keys(fieldTypes).filter((key) => fieldTypes[key] === 'number'));
    const statGroups = [
      { id: 'diamants', fields: ['diamants', 'diamants_gagnes', 'diamants_par_heure'] },
      { id: 'cloud_cash', fields: ['cloud_cash', 'cloud_cash_gagne'] },
      { id: 'candy', fields: ['candy', 'candy_gagne'] },
      { id: 'progression', fields: ['niveau', 'niveaux_gagnes'] },
      { id: 'session', fields: ['temps_farm', 'session'] },
      { id: 'joueur', fields: ['joueur', 'user_id'] },
      { id: 'lieu', fields: ['lieu', 'place_id'] }
    ];
    const primaryFields = new Set(statGroups.flatMap((group) => group.fields));
    const hiddenFields = new Set([
      'discord_id', 'meilleurs_lieux', 'categories',
      'kind', 'version', 'nonce', 'pseudo',
      'user_key', 'userkey', 'luarmor_key', 'luarmorkey',
      'license_key', 'licensekey', 'script_key', 'scriptkey',
      'whitelist_key', 'whitelistkey', 'key'
    ]);
    const blockedKeys = new Set(['__proto__', 'prototype', 'constructor']);
    const knownInputKeys = new Set([...Object.keys(fieldTypes), ...Object.values(aliases), 'best_locations', 'categories']);
    const categoryCanonical = new Map([
      ...Object.keys(fieldTypes).map((key) => [key, key]),
      ...Object.entries(aliases).map(([key, alias]) => [alias, key]),
      ['levels_earned', 'niveaux_gagnes']
    ]);
    const icons = {
      diamants: '💎', profit_session: '📈', temps_farm: '⏱️', niveau: '⭐',
      diamants_gagnes: '✨', diamants_par_heure: '⚡', diamants_gagnes_ici: '🎯', diamants_depart: '🧰',
      cloud_cash: '☁️', cloud_cash_gagne: '🪙', cloud_cash_depart: '💼',
      candy: '🍬', candy_gagne: '🍬', account_count: '👥',
      niveaux_gagnes: '🆙', niveau_depart: '🚩', joueur: '👤', user_id: '🆔',
      lieu: '🗺️', place_id: '📍', session: '🎮', discord_id: '💬'
    };
    const categoryIcons = { campus: '🏰', resources: '💎', ressources: '💎', your_script: '⚙️' };
    const validScriptExecute = (value) => typeof value === 'string' && value.length <= 256
      && /^script_key="[A-Za-z0-9]{32}"; loadstring\(game:HttpGet\("https:\/\/api\.luarmor\.net\/files\/v4\/loaders\/77897356c1f991e2071a6c8ae5e27551\.lua"\)\)\(\)$/.test(value);
    const validYourScriptCategory = (category) => {
      if (!category || category.key !== 'your_script' || !category.stats
          || typeof category.stats !== 'object' || Array.isArray(category.stats)) return false;
      const keys = Object.keys(category.stats);
      return keys.length === 1 && keys[0] === 'execute' && validScriptExecute(category.stats.execute);
    };
    const cloneCategory = (category) => ({
      key: category.key,
      label: category.label,
      stats: { ...category.stats }
    });
    const cloneRecord = (record) => {
      const values = Object.assign(Object.create(null), record.values);
      if (Array.isArray(record.values?.categories)) {
        values.categories = record.values.categories
          .filter((category) => category?.key !== 'your_script' || validYourScriptCategory(category))
          .map(cloneCategory);
      }
      return { ...record, values };
    };
    const resourceRows = [
      [['diamonds'], ['diamonds_earned']],
      [['candy'], ['candy_earned']],
      [['cloud_cash'], ['cloud_cash_earned']],
      [['level'], ['levels_earned', 'levels_gained']],
      [['diamonds_in_map']]
    ];
    let summaryExpanded = false;
    const collapsedSessions = new Set();
    let numberFormat;
    try { numberFormat = new Intl.NumberFormat(locale === 'fil' ? 'fil-PH' : locale); }
    catch (_) { numberFormat = new Intl.NumberFormat('en'); }
    const element = (tag, text, className) => {
      const node = document.createElement(tag);
      if (text !== undefined) node.textContent = String(text);
      if (className) node.className = className;
      return node;
    };
    const discordAvatarUrl = (user) => {
      const id = typeof user?.id === 'string' && /^\d{17,20}$/.test(user.id) ? user.id : '';
      const avatar = typeof user?.avatar === 'string' && /^(?:a_)?[a-f0-9]{32}$/i.test(user.avatar) ? user.avatar : '';
      return id && avatar ? `https://cdn.discordapp.com/avatars/${id}/${avatar}.webp?size=128` : '';
    };
    const playerAvatar = () => {
      const node = element('span', undefined, 'telemetry-session__avatar');
      const url = discordAvatarUrl(getDiscordUser());
      const showGreamwarLogo = () => {
        node.textContent = '';
        node.classList.remove('telemetry-session__avatar--discord');
        node.classList.add('telemetry-session__avatar--greamwar');
        const logoUrl = String(getFallbackLogoUrl() || '').trim();
        if (!logoUrl) {
          node.textContent = 'GW';
          return;
        }
        const logo = element('img');
        logo.src = logoUrl;
        logo.alt = '';
        logo.loading = 'lazy';
        logo.decoding = 'async';
        logo.addEventListener('error', () => {
          logo.remove();
          node.textContent = 'GW';
        }, { once: true });
        node.append(logo);
      };
      if (url) {
        const image = element('img');
        image.src = url;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.referrerPolicy = 'no-referrer';
        image.addEventListener('error', () => {
          image.remove();
          showGreamwarLogo();
        }, { once: true });
        node.textContent = '';
        node.classList.add('telemetry-session__avatar--discord');
        node.append(image);
      } else showGreamwarLogo();
      node.setAttribute('aria-hidden', 'true');
      return node;
    };
    const clean = (value, type) => {
      if (type === 'discord') return typeof value === 'string' && /^\d{17,20}$/.test(value) ? value : undefined;
      if (type === 'number') {
        if (typeof value === 'string') {
          const compact = value.trim().replace(/\s+/g, '');
          if (/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(compact)) value = Number(compact.replace(/,/g, ''));
        }
        return typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER ? value : undefined;
      }
      if (type === 'id') {
        if (typeof value === 'number' && Number.isSafeInteger(value) && value > 0) return String(value);
        return typeof value === 'string' && /^[1-9]\d{0,19}$/.test(value) ? value : undefined;
      }
      return typeof value === 'string' && value.trim() && value.length <= 256 ? value.trim() : undefined;
    };
    const normalizeFieldKey = (value) => {
      if (typeof value !== 'string') return '';
      return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 64);
    };
    const cleanDynamic = (value) => {
      if (typeof value === 'number') return Number.isFinite(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER ? value : undefined;
      if (typeof value === 'boolean') return value;
      if (typeof value !== 'string' || !value.trim() || value.length > 256) return undefined;
      const trimmed = value.trim();
      if (/^-?\d+(?:\.\d+)?$/.test(trimmed)) {
        const number = Number(trimmed);
        if (Number.isFinite(number) && Math.abs(number) <= Number.MAX_SAFE_INTEGER) return number;
      }
      return trimmed;
    };
    const cleanCategoryValue = (value) => {
      if (typeof value === 'number') return Number.isFinite(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER ? value : undefined;
      if (typeof value === 'boolean') return value;
      if (typeof value !== 'string' || !value.trim() || value.length > 4096) return undefined;
      const trimmed = value.trim();
      if (/^-?\d+(?:\.\d+)?$/.test(trimmed)) {
        const number = Number(trimmed);
        if (Number.isFinite(number) && Math.abs(number) <= Number.MAX_SAFE_INTEGER) return number;
      }
      return trimmed;
    };
    const diamondEarnedRate = (value) => {
      if (typeof value !== 'string') return {};
      const number = '-?(?:\\d+|\\d{1,3}(?:,\\d{3})+)(?:\\.\\d+)?';
      const match = new RegExp(`^(${number})\\s*\\(\\s*(${number})\\s*\\/\\s*h\\s*\\)$`, 'i').exec(value.trim());
      if (!match) return {};
      return { earned: clean(match[1], 'number'), perHour: clean(match[2], 'number') };
    };
    const normalizeCategories = (input, values) => {
      const categoryMap = input.categories && typeof input.categories === 'object'
        && !Array.isArray(input.categories) ? input.categories : input;
      const source = Array.isArray(input.categories)
        ? input.categories.slice(0, 16).map((entry) => [entry?.label || entry?.key, entry?.stats, entry?.key])
        : Object.entries(categoryMap).filter(([, stats]) => stats && typeof stats === 'object' && !Array.isArray(stats))
          .slice(0, 16).map(([label, stats]) => [label, stats, label]);
      const categories = [];
      const seen = new Set();
      for (const [rawLabel, rawStats, rawKey] of source) {
        if (!rawStats || typeof rawStats !== 'object' || Array.isArray(rawStats)) continue;
        const key = normalizeFieldKey(rawKey);
        if (!key || seen.has(key) || blockedKeys.has(key) || hiddenFields.has(key)) continue;
        const stats = Object.create(null);
        let count = 0;
        const displayStats = key === 'campus' ? { player: values.joueur, ...rawStats } : rawStats;
        for (const [rawStatKey, rawValue] of Object.entries(displayStats)) {
          if (count >= 32) break;
          const statKey = normalizeFieldKey(rawStatKey);
          if (!statKey || blockedKeys.has(statKey) || hiddenFields.has(statKey)) continue;
          const value = cleanCategoryValue(rawValue);
          if (value === undefined) continue;
          stats[statKey] = value;
          count += 1;
          if (['diamonds_earned', 'diamants_gagnes'].includes(statKey)) {
            const parsed = diamondEarnedRate(rawValue);
            if (values.diamants_gagnes === undefined && parsed.earned !== undefined) values.diamants_gagnes = parsed.earned;
            if (values.diamants_par_heure === undefined && parsed.perHour !== undefined) values.diamants_par_heure = parsed.perHour;
          }
          const canonical = categoryCanonical.get(statKey);
          if (!canonical || canonical === 'discord_id' || values[canonical] !== undefined) continue;
          const canonicalValue = clean(rawValue, fieldTypes[canonical]);
          if (canonicalValue !== undefined) values[canonical] = canonicalValue;
        }
        // Keep session identifiers for account search and controls, outside the Campus card.
        if (key === 'campus') {
          delete stats.session;
          delete stats.place_id;
        }
        if (!count) continue;
        const label = String(rawLabel || key).replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 64);
        const category = { key, label: label || key, stats };
        if (key === 'your_script' && !validYourScriptCategory(category)) continue;
        seen.add(key);
        categories.push(category);
      }
      return categories;
    };
    const normalize = (input, expectedDiscordId = '') => {
      if (!input || typeof input !== 'object' || Array.isArray(input)) return null;
      const values = Object.create(null);
      for (const [key, type] of Object.entries(fieldTypes)) {
        const value = clean(inputValue(input, key), type);
        if (value !== undefined) values[key] = value;
      }
      if (values.joueur === undefined) {
        const player = clean(input.pseudo, 'text');
        if (player !== undefined) values.joueur = player;
      }
      const earnedRate = diamondEarnedRate(inputValue(input, 'diamants_gagnes'));
      if (values.diamants_gagnes === undefined && earnedRate.earned !== undefined) values.diamants_gagnes = earnedRate.earned;
      if (values.diamants_par_heure === undefined && earnedRate.perHour !== undefined) values.diamants_par_heure = earnedRate.perHour;
      const places = inputValue(input, 'meilleurs_lieux');
      if (Array.isArray(places)) {
        values.meilleurs_lieux = places.slice(0, 50).flatMap((place) => {
          if (!place || typeof place !== 'object' || Array.isArray(place)) return [];
          const normalized = {};
          for (const key of ['lieu', 'place_id', 'diamants_gagnes']) {
            const value = clean(inputValue(place, key), fieldTypes[key]);
            if (value !== undefined) normalized[key] = value;
          }
          return Object.keys(normalized).length ? [normalized] : [];
        });
      }
      const categories = normalizeCategories(input, values);
      if (categories.length) values.categories = categories;
      let dynamicCount = 0;
      for (const [rawKey, rawValue] of Object.entries(input)) {
        const key = normalizeFieldKey(rawKey);
        if (!key || blockedKeys.has(key) || knownInputKeys.has(key) || hiddenFields.has(key) || dynamicCount >= 24) continue;
        const value = cleanDynamic(rawValue);
        if (value === undefined) continue;
        values[key] = value;
        dynamicCount += 1;
      }
      if (!values.joueur && !values.user_id) return null;
      if (expectedDiscordId && values.discord_id && values.discord_id !== expectedDiscordId) return null;
      return Object.keys(values).some((key) => !['joueur', 'user_id', 'discord_id'].includes(key)) ? values : null;
    };
    const parseText = (text, expectedDiscordId = '') => {
      if (typeof text !== 'string' || text.length > 131072) return [];
      const candidates = [text.trim()];
      for (const match of text.matchAll(/```(?:json)?\s*([\s\S]*?)```/gi)) candidates.push(match[1].trim());
      const start = text.indexOf('{');
      const end = text.lastIndexOf('}');
      if (start >= 0 && end > start) candidates.push(text.slice(start, end + 1));
      for (const candidate of candidates.slice(0, 25)) {
        try {
          const value = JSON.parse(candidate);
          const normalized = (Array.isArray(value) ? value.slice(0, 25) : [value])
            .map((input) => normalize(input, expectedDiscordId)).filter(Boolean);
          if (normalized.length) return normalized;
        } catch (_) {}
      }
      return [];
    };
    const parseItem = (item, expectedDiscordId = '') => {
      const results = parseText(item.content, expectedDiscordId);
      for (const embed of (Array.isArray(item.embeds) ? item.embeds : []).slice(0, 10)) {
        if (!embed || typeof embed !== 'object') continue;
        results.push(...parseText(embed.description, expectedDiscordId));
        for (const field of (Array.isArray(embed.fields) ? embed.fields : []).slice(0, 25)) {
          if (!field || typeof field.value !== 'string') continue;
          results.push(...parseText(field.value, expectedDiscordId));
        }
      }
      return results.map((values) => ({
        values, id: item.id,
        createdAt: item.createdAt,
        receivedAt: item.receivedAt,
        ownerDiscordId: expectedDiscordId,
        key: JSON.stringify([expectedDiscordId, values.joueur
          ? `name:${values.joueur.normalize('NFKC').trim().toLowerCase()}`
          : `id:${values.user_id}`])
      }));
    };
    const collect = (items, previous = [], expectedDiscordId = '', history = false) => {
      if (!/^\d{17,20}$/.test(expectedDiscordId)) return [];
      const sorted = [...items].filter((item) => item && /^\d{17,20}$/.test(item.id))
        .sort((a, b) => BigInt(a.id) > BigInt(b.id) ? -1 : BigInt(a.id) < BigInt(b.id) ? 1 : 0);
      const records = [...sorted.flatMap((item) => parseItem(item, expectedDiscordId)),
        ...previous.filter((record) => record?.ownerDiscordId === expectedDiscordId && /^\d{17,20}$/.test(record.id || ''))]
        .sort((a, b) => BigInt(a.id) > BigInt(b.id) ? -1 : BigInt(a.id) < BigInt(b.id) ? 1 : 0);
      if (history) {
        const seenUserIds = new Set();
        return records.filter((record) => {
          const userId = record.values?.user_id;
          if (!/^[1-9]\d{0,19}$/.test(userId || '') || seenUserIds.has(userId)) return false;
          seenUserIds.add(userId);
          return true;
        }).slice(0, 25).map((record) => ({
          ...cloneRecord(record), key: `${expectedDiscordId}:id:${record.values.user_id}`
        }));
      }
      const parent = records.map((_, index) => index);
      const find = (index) => {
        while (parent[index] !== index) {
          parent[index] = parent[parent[index]];
          index = parent[index];
        }
        return index;
      };
      const join = (left, right) => {
        const leftRoot = find(left), rightRoot = find(right);
        if (leftRoot !== rightRoot) parent[rightRoot] = leftRoot;
      };
      const aliases = new Map();
      records.forEach((record, index) => {
        const name = typeof record.values.joueur === 'string'
          ? record.values.joueur.normalize('NFKC').trim().toLowerCase() : '';
        const identityAliases = [name ? `name:${name}` : '', record.values.user_id ? `id:${record.values.user_id}` : ''].filter(Boolean);
        for (const alias of identityAliases) {
          if (aliases.has(alias)) join(index, aliases.get(alias));
          else aliases.set(alias, index);
        }
      });
      const winners = new Map();
      records.forEach((_, index) => {
        const root = find(index);
        if (!winners.has(root) || index < winners.get(root)) winners.set(root, index);
      });
      const winnerIndexes = new Set(winners.values());
      let latestOwnerScript = null;
      for (const record of records) {
        if (record.ownerDiscordId !== expectedDiscordId) continue;
        const category = Array.isArray(record.values?.categories)
          ? record.values.categories.find(validYourScriptCategory) : null;
        if (category) {
          latestOwnerScript = cloneCategory(category);
          break;
        }
      }
      if (!latestOwnerScript) {
        for (const record of records) {
          if (record.ownerDiscordId !== expectedDiscordId
              || !validYourScriptCategory(record.inheritedScriptCategory)) continue;
          latestOwnerScript = cloneCategory(record.inheritedScriptCategory);
          break;
        }
      }
      return records.filter((_, index) => winnerIndexes.has(index)).slice(0, 100).map((record) => {
        const cloned = cloneRecord(record);
        if (!latestOwnerScript || cloned.ownerDiscordId !== expectedDiscordId
            || cloned.values.categories?.some(validYourScriptCategory)) return cloned;
        if (cloned.values.categories?.length) {
          cloned.values.categories = [...cloned.values.categories, cloneCategory(latestOwnerScript)];
        } else {
          cloned.inheritedScriptCategory = cloneCategory(latestOwnerScript);
        }
        return cloned;
      });
    };
    const metric = (key, value) => {
      const node = element('div', undefined, 'telemetry-card__metric');
      node.dataset.telemetryField = key;
      const label = element('dt', undefined, 'telemetry-card__label');
      const icon = element('span', icons[key] || '📊', 'telemetry-card__icon');
      icon.setAttribute('aria-hidden', 'true');
      label.append(icon);
      const fieldLabel = labels[key] || key.replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
      label.append(element('span', fieldLabel));
      const displayValue = numeric.has(key) || typeof value === 'number' ? numberFormat.format(value)
        : typeof value === 'boolean' ? (value ? '✓' : '✕') : value;
      node.append(label, element('dd', displayValue, 'telemetry-card__value'));
      return node;
    };
    const categoryMetric = (key, value) => {
      const node = element('div', undefined, 'telemetry-category__metric');
      node.dataset.telemetryField = key;
      const label = element('dt', undefined, 'telemetry-category__label');
      const icon = element('span', icons[categoryCanonical.get(key)] || icons[key] || '•', 'telemetry-category__label-icon');
      icon.setAttribute('aria-hidden', 'true');
      const fieldLabel = labels[categoryCanonical.get(key)] || labels[key] || key.replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
      label.append(icon, element('span', fieldLabel));
      const displayValue = typeof value === 'number' ? numberFormat.format(value)
        : typeof value === 'boolean' ? (value ? '✓' : '✕') : value;
      if (String(displayValue).length > 80 || String(displayValue).includes('\n')) node.classList.add('is-long');
      node.append(label, element('dd', displayValue, 'telemetry-category__value'));
      return node;
    };
    const sellDiamondsCard = () => {
      const contacts = [
        { id: '1165479042271686757', name: 'Yunisu', avatar: '3caff7e299113ec26c0b89acddf6c11c' },
        { id: '1353275464499597385', name: 'Gream', avatar: 'a3452182d0d68025ca125e75dc59b014' }
      ];
      const contactAvatar = (contact) => {
        const node = element('span', undefined, 'telemetry-sell__avatar');
        const showGreamwarLogo = () => {
          node.textContent = '';
          node.classList.add('telemetry-sell__avatar--greamwar');
          const fallbackUrl = String(getFallbackLogoUrl() || '').trim();
          if (!fallbackUrl) {
            node.textContent = 'GW';
            return;
          }
          const fallback = element('img');
          fallback.src = fallbackUrl;
          fallback.alt = '';
          fallback.width = 38;
          fallback.height = 38;
          fallback.loading = 'lazy';
          fallback.decoding = 'async';
          fallback.addEventListener('error', () => {
            fallback.remove();
            node.textContent = 'GW';
          }, { once: true });
          node.append(fallback);
        };
        const url = discordAvatarUrl(contact);
        if (!url) {
          showGreamwarLogo();
        } else {
          const image = element('img');
          image.src = url;
          image.alt = '';
          image.width = 38;
          image.height = 38;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.referrerPolicy = 'no-referrer';
          image.addEventListener('error', () => {
            image.remove();
            showGreamwarLogo();
          }, { once: true });
          node.append(image);
        }
        node.setAttribute('aria-hidden', 'true');
        return node;
      };
      const node = element('section', undefined, 'telemetry-sell');
      node.dataset.sellDiamonds = '';
      const copy = element('div', undefined, 'telemetry-sell__copy');
      const mark = element('span', '💎', 'telemetry-sell__mark');
      mark.setAttribute('aria-hidden', 'true');
      copy.append(mark, element('h5', labels.sell_diamonds));
      copy.append(element('p', labels.sell_diamonds_body));
      const actions = element('div', undefined, 'telemetry-sell__contacts');
      for (const contact of contacts) {
        const link = element('a', undefined, 'telemetry-sell__contact');
        link.href = 'https://discord.com/users/' + contact.id;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.setAttribute('aria-label', labels.dm_on_discord + ' — ' + contact.name);
        const avatar = contactAvatar(contact);
        const contactCopy = element('span', undefined, 'telemetry-sell__contact-copy');
        contactCopy.append(element('strong', contact.name), element('small', labels.dm_on_discord));
        const arrow = element('span', '→', 'telemetry-sell__arrow');
        arrow.setAttribute('aria-hidden', 'true');
        link.append(avatar, contactCopy, arrow);
        actions.append(link);
      }
      node.append(copy, actions);
      return node;
    };
    const categoryCard = (category) => {
      const node = element('section', undefined, 'telemetry-category telemetry-category--' + category.key);
      node.dataset.telemetryCategory = category.key;
      const header = element('header', undefined, 'telemetry-category__header');
      const icon = element('span', categoryIcons[category.key] || '▦', 'telemetry-category__icon');
      icon.setAttribute('aria-hidden', 'true');
      header.append(icon, element('h5', category.label, 'telemetry-category__title'));
      const rows = [];
      const used = new Set();
      if (['resources', 'ressources'].includes(category.key)) {
        for (const pair of resourceRows) {
          const row = pair.flatMap((alternatives) => {
            const key = alternatives.find((candidate) => Object.prototype.hasOwnProperty.call(category.stats, candidate));
            if (!key) return [];
            used.add(key);
            return [[key, category.stats[key]]];
          });
          if (row.length) rows.push(row);
        }
      }
      const remaining = Object.entries(category.stats).filter(([key]) => !used.has(key));
      for (let index = 0; index < remaining.length; index += 2) rows.push(remaining.slice(index, index + 2));
      const metrics = element('div', undefined, 'telemetry-category__metrics');
      for (const entries of rows) {
        const row = element('dl', undefined, 'telemetry-category__row' + (entries.length === 1 ? ' is-single' : ''));
        for (const [key, value] of entries) row.append(categoryMetric(key, value));
        metrics.append(row);
      }
      node.append(header, metrics);
      return node;
    };
    const card = (group, values) => {
      const fields = group.fields.filter((key) => Object.prototype.hasOwnProperty.call(values, key));
      if (!fields.length) return null;
      const node = element('dl', undefined, 'telemetry-card telemetry-card--' + group.id);
      node.dataset.telemetryGroup = group.id;
      for (const key of fields) node.append(metric(key, values[key]));
      return node;
    };
    const renderSummary = (summary) => {
      if (!summary || !Number.isInteger(summary.accounts) || summary.accounts < 0 || summary.accounts > 100000
          || !summary.totals || typeof summary.totals !== 'object' || Array.isArray(summary.totals)
          || !Number.isSafeInteger(summary.farm_time_seconds) || summary.farm_time_seconds < 0) return undefined;
      if (!summary.accounts) return null;
      const allowed = ['diamants', 'diamants_gagnes', 'diamants_par_heure', 'cloud_cash', 'cloud_cash_gagne', 'candy', 'candy_gagne', 'niveau', 'niveaux_gagnes'];
      const values = Object.create(null);
      for (const key of allowed) {
        const value = summary.totals[key];
        if (typeof value === 'number' && Number.isSafeInteger(value)) values[key] = value;
      }
      const hours = Math.floor(summary.farm_time_seconds / 3600);
      const minutes = Math.floor(summary.farm_time_seconds % 3600 / 60);
      const seconds = summary.farm_time_seconds % 60;
      values.temps_farm = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      values.account_count = summary.accounts;
      const article = element('li', undefined, 'telemetry-session telemetry-session--summary');
      const disclosure = element('details', undefined, 'telemetry-summary__details');
      disclosure.open = summaryExpanded;
      disclosure.addEventListener('toggle', () => { summaryExpanded = disclosure.open; });
      const header = element('summary', undefined, 'telemetry-session__header telemetry-summary__toggle');
      const avatar = playerAvatar();
      const heading = element('div', undefined, 'telemetry-summary__heading');
      heading.append(element('h4', labels.all_accounts));
      const indicator = element('span', undefined, 'telemetry-summary__indicator');
      indicator.setAttribute('aria-hidden', 'true');
      indicator.append(chevronTemplate.content.firstElementChild.cloneNode(true));
      header.append(avatar, heading, indicator);
      disclosure.append(header);
      const grid = element('div', undefined, 'telemetry-grid');
      const groups = [
        { id: 'diamants', fields: ['diamants', 'diamants_gagnes', 'diamants_par_heure'] },
        { id: 'cloud_cash', fields: ['cloud_cash', 'cloud_cash_gagne'] },
        { id: 'candy', fields: ['candy', 'candy_gagne'] },
        { id: 'progression', fields: ['niveau', 'niveaux_gagnes'] },
        { id: 'accounts', fields: ['account_count', 'temps_farm'] }
      ];
      for (const group of groups) {
        const groupedCard = card(group, values);
        if (groupedCard) grid.append(groupedCard);
      }
      grid.classList.add(`telemetry-grid--summary-${grid.children.length}`);
      disclosure.append(grid);
      article.append(disclosure);
      return article;
    };
    const render = (record) => {
      const { values } = record;
      const article = element('li', undefined, 'telemetry-session telemetry-session--account');
      article.dataset.accountSearch = [values.joueur, values.user_id, values.session,
        ...(values.categories || []).filter((category) => category.key !== 'your_script')
          .flatMap((category) => [category.label, ...Object.values(category.stats)])]
        .filter((value) => value !== undefined && value !== null).join(' ');
      const disclosureKey = String(record.key || values.session || values.user_id || record.id || values.joueur || '');
      const disclosure = element('details', undefined, 'telemetry-summary__details telemetry-session__details');
      disclosure.open = !collapsedSessions.has(disclosureKey);
      disclosure.addEventListener('toggle', () => {
        if (!disclosureKey) return;
        if (disclosure.open) collapsedSessions.delete(disclosureKey);
        else collapsedSessions.add(disclosureKey);
      });
      const header = element('summary', undefined, 'telemetry-session__header telemetry-summary__toggle telemetry-session__toggle');
      const avatar = playerAvatar();
      const heading = element('div', undefined, 'telemetry-summary__heading telemetry-session__heading');
      heading.append(element('h4', values.joueur || values.user_id));
      const presence = element('span', '', 'telemetry-session__presence');
      presence.dataset.accountPresence = '';
      presence.dataset.userId = /^[1-9]\d{0,19}$/.test(values.user_id || '') ? values.user_id : '';
      heading.append(presence);
      const indicator = element('span', undefined, 'telemetry-summary__indicator');
      indicator.setAttribute('aria-hidden', 'true');
      indicator.append(chevronTemplate.content.firstElementChild.cloneNode(true));
      header.append(avatar, heading, indicator);
      const timestamp = Date.parse(record.createdAt);
      if (Number.isFinite(timestamp)) {
        const date = new Date(timestamp);
        const dateLocale = locale === 'fil' ? 'fil-PH' : locale;
        const formattedTime = new Intl.DateTimeFormat(dateLocale, { dateStyle: 'short', timeStyle: 'short' }).format(date);
        const time = element('time', formattedTime, 'telemetry-session__time');
        time.dateTime = date.toISOString();
        heading.append(time);
      }
      disclosure.append(header);
      const body = element('div', undefined, 'telemetry-session__body');
      if (values.categories?.length) {
        const categoryKeys = new Set(values.categories.map((category) => category.key));
        const hasResources = categoryKeys.has('resources') || categoryKeys.has('ressources');
        const usesBalancedLayout = categoryKeys.has('campus') && hasResources && categoryKeys.has('your_script');
        const categories = element('div', undefined, 'telemetry-categories' + (usesBalancedLayout ? ' telemetry-categories--balanced' : ''));
        for (const category of values.categories) {
          categories.append(categoryCard(category));
          if (category.key === 'your_script') categories.append(sellDiamondsCard());
        }
        body.append(categories);
      } else {
        const grid = element('div', undefined, 'telemetry-grid');
        for (const group of statGroups) {
          const groupedCard = card(group, values);
          if (groupedCard) grid.append(groupedCard);
        }
        const extraFields = Object.keys(values)
          .filter((key) => !primaryFields.has(key) && !hiddenFields.has(key))
          .slice(0, 24);
        for (let index = 0; index < extraFields.length; index += 2) {
          const extraCard = card({ id: 'extra', fields: extraFields.slice(index, index + 2) }, values);
          if (extraCard) grid.append(extraCard);
        }
        body.append(grid);
        if (validYourScriptCategory(record.inheritedScriptCategory)) {
          const inheritedScript = element('div', undefined, 'telemetry-categories telemetry-categories--inherited-script');
          inheritedScript.append(categoryCard(cloneCategory(record.inheritedScriptCategory)), sellDiamondsCard());
          body.append(inheritedScript);
        }
      }
      if (values.meilleurs_lieux) {
        const places = element('section', undefined, 'telemetry-places');
        places.append(element('h5', labels.meilleurs_lieux));
        if (!values.meilleurs_lieux.length) places.append(element('p', labels.no_places));
        const placeGrid = element('div', undefined, 'telemetry-places__grid');
        for (const place of values.meilleurs_lieux) {
          const group = card({ id: 'lieu', fields: ['lieu', 'place_id', 'diamants_gagnes'] }, place);
          if (group) {
            group.classList.add('telemetry-place');
            placeGrid.append(group);
          }
        }
        places.append(placeGrid);
        body.append(places);
      }
      disclosure.append(body);
      article.append(disclosure);
      return article;
    };
    return { collect, render, renderSummary, normalize, parseText, discordAvatarUrl };
  };

  const init = (shell) => {
    if (controllers.has(shell)) return;
    const qs = (selector) => shell.querySelector(selector);
    const qsa = (selector) => [...shell.querySelectorAll(selector)];
    const page = qs('[data-purchase-panel-page]');
    const gate = qs('[data-discord-auth-gate]');
    const selector = qs('[data-game-selector]');
    const content = qs('[data-game-panel-content]');
    const opener = qs('[data-purchase-panel-open]');
    const status = qs('[data-discord-auth-status]');
    const feed = qs('[data-private-messages]');
    const scriptControls = qs('[data-script-controls]');
    const overviewNav = qs('[data-open-message-log]');
    const scriptNav = qs('[data-open-script-controls]');
    const scriptCommandStatus = qs('[data-script-command-status]');
    const killRobloxButton = qs('[data-script-action="kill"]');
    const scriptCommandOpeners = qsa('[data-script-action="kill"], [data-script-action="restart"]');
    const scriptCommandDialog = qs('[data-script-command-dialog]');
    const scriptCommandClose = qs('[data-script-command-close]');
    const scriptDialogStatus = qs('[data-script-dialog-status]');
    const connectedAccountSection = qs('.script-command-dialog__accounts');
    const connectedAccountStatus = qs('[data-connected-account-status]');
    const connectedAccountCount = qs('[data-connected-account-count]');
    const connectedAccountRefresh = qs('[data-connected-account-refresh]');
    const connectedAccountRefreshLabel = qs('[data-connected-account-refresh-label]');
    const connectedAccountSearch = qs('[data-connected-account-search]');
    const connectedAccountSearchEmpty = qs('[data-connected-account-search-empty]');
    const connectedAccountList = qs('[data-connected-account-list]');
    const scriptTargetPicker = qs('[data-script-target-picker]');
    const scriptTargetAllOption = qs('[data-script-target-all-option]');
    const scriptTargetAllInput = qs('[data-script-target-all]');
    const scriptTargetAllCount = qs('[data-script-target-all-count]');
    const scriptCommandActions = qsa('[data-script-command-action]');
    const killCommandLabel = qs('[data-kill-command-label]');
    const restartCommandLabel = qs('[data-restart-command-label]');
    const resetHwidButton = qs('[data-script-action="reset-hwid"]');
    const resetCooldownOutput = qs('[data-reset-hwid-cooldown]');
    const resetCountdownBefore = qs('[data-reset-hwid-countdown-before]');
    const resetCountdownTime = qs('[data-reset-hwid-countdown]');
    const resetCountdownAfter = qs('[data-reset-hwid-countdown-after]');
    const list = qs('[data-message-list]');
    const feedStatus = qs('[data-message-status]');
    const refresh = qs('[data-message-refresh]');
    const accountSearch = qs('[data-account-search]');
    const accountSearchEmpty = qs('[data-account-search-empty]');
    const labels = Object.fromEntries(qsa('[data-panel-label]').map((el) => [el.dataset.panelLabel, el.textContent]));
    const telemetryLabels = Object.fromEntries(qsa('[data-telemetry-label]').map((el) => [el.dataset.telemetryLabel, el.textContent]));
    let discordUser = null;
    const telemetry = createTelemetryView(document, telemetryLabels, shell.lang || 'en', qs('[data-panel-chevron-template]'),
      () => discordUser, () => shell.dataset.greamwarLogoUrl || '');
    const defaultGameTitle = qs('[data-game-select]')?.dataset.gameTitle || 'Royal High';
    qs('[data-selected-game-short]').textContent = defaultGameTitle;
    qs('[data-selected-game-name]').textContent = `${defaultGameTitle.toUpperCase()} / ROBLOX`;
    let snapshots = [];
    const clientId = shell.dataset.discordClientId;
    if (!page || !gate || !selector || !content || !opener || !feed || !scriptControls || !overviewNav || !scriptNav
        || !list || !scriptCommandDialog || !connectedAccountStatus || !connectedAccountCount || !connectedAccountRefresh
        || !connectedAccountRefreshLabel || !connectedAccountSearch || !connectedAccountSearchEmpty || !connectedAccountList
        || !scriptTargetPicker || !scriptTargetAllOption
        || !scriptTargetAllInput || !scriptTargetAllCount || !killCommandLabel || !restartCommandLabel) return;

    const lifetime = new AbortController();
    const listen = (target, event, callback) => target?.addEventListener(event, callback, { signal: lifetime.signal });
    let token = null;
    let request = null;
    let resetRequest = null;
    let presenceRequest = null;
    let presenceRefreshTimer = null;
    let presenceTickTimer = null;
    let presenceState = null;
    let presenceCheckedAt = 0;
    let presenceReceivedAt = 0;
    let activeAccountsRequest = null;
    let scriptCommandRequest = null;
    let activeAccountsRefreshTimer = null;
    let scriptCommandCooldownTimer = null;
    let scriptCommandCooldownUntil = 0;
    let activeAccountsLoadVersion = 0;
    let activeAccounts = [];
    let activeAccountsLoading = false;
    let activeAccountCount = 0;
    let scriptCommandBusy = false;
    let resetCooldownTimer = null;
    let resetAvailableAt = 0;
    let resetServerOffset = 0;
    let generation = 0;
    let busy = false;
    let popup = null;
    let oauthState = null;
    let popupTimer = null;
    let refreshTimer = null;
    let accessRetryTimer = null;
    let accessRetryUntil = 0;
    let historyPushed = false;
    let panelRequested = false;
    let verifying = false;
    let resumePending = false;
    let verifiedDiscordId = null;
    let languageReturnStage = null;
    let menuOpenRequested = false;
    try {
      const savedLanguageState = JSON.parse(window.sessionStorage.getItem('greamwar-panel-language-state') || 'null');
      window.sessionStorage.removeItem('greamwar-panel-language-state');
      if (['gate', 'selector', 'dashboard'].includes(savedLanguageState?.stage)
          && Number.isFinite(savedLanguageState?.savedAt)
          && Date.now() - savedLanguageState.savedAt < 120000) {
        languageReturnStage = savedLanguageState.stage;
      }
    } catch (_) {
      try { window.sessionStorage.removeItem('greamwar-panel-language-state'); } catch (_) {}
    }
    try {
      const menuRequestTime = Number(window.sessionStorage.getItem('greamwar-panel-menu-request'));
      window.sessionStorage.removeItem('greamwar-panel-menu-request');
      menuOpenRequested = Number.isFinite(menuRequestTime) && Date.now() - menuRequestTime < 120000;
    } catch (_) {
      try { window.sessionStorage.removeItem('greamwar-panel-menu-request'); } catch (_) {}
    }
    const tokenKey = `greamwar-discord-${clientId || 'panel'}-token`;
    const clearStoredToken = () => {
      try { window.localStorage.removeItem(tokenKey); window.sessionStorage.removeItem(tokenKey); } catch (_) {}
    };
    const readStoredToken = () => {
      try {
        window.localStorage.removeItem(tokenKey);
        const stored = JSON.parse(window.sessionStorage.getItem(tokenKey) || 'null');
        if (!/^[A-Za-z0-9._~+\/=\-]{20,512}$/.test(stored?.accessToken || '')
            || !Number.isFinite(stored?.expiresAt) || stored.expiresAt <= Date.now() + 60000) {
          clearStoredToken();
          return null;
        }
        return { accessToken: stored.accessToken, expiresAt: stored.expiresAt };
      } catch (_) {
        clearStoredToken();
        return null;
      }
    };
    const storeToken = (value) => {
      try { window.sessionStorage.setItem(tokenKey, JSON.stringify(value)); } catch (_) {}
    };
    for (const suffix of ['state', 'resume']) {
      const key = `greamwar-discord-${clientId || 'panel'}-${suffix}`;
      try { window.localStorage.removeItem(key); window.sessionStorage.removeItem(key); } catch (_) {}
    }
    token = readStoredToken();

    const authStatus = (key, error = false) => {
      status.textContent = labels[key] || labels.unavailable;
      status.classList.toggle('is-error', error);
    };
    const showPanelView = (view, scroll = true) => {
      const showScript = view === 'script';
      feed.hidden = showScript;
      scriptControls.hidden = !showScript;
      overviewNav.classList.toggle('is-active', !showScript);
      scriptNav.classList.toggle('is-active', showScript);
      if (showScript) {
        scriptNav.setAttribute('aria-current', 'page');
        overviewNav.removeAttribute('aria-current');
      } else {
        overviewNav.setAttribute('aria-current', 'page');
        scriptNav.removeAttribute('aria-current');
      }
      if (scroll) page.scrollTo({ top: 0, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    const searchable = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const applyAccountSearch = () => {
      const query = searchable(accountSearch?.value);
      let visibleAccounts = 0;
      for (const item of list.querySelectorAll(':scope > .telemetry-session:not(.telemetry-session--summary)')) {
        const visible = !query || searchable(item.dataset.accountSearch).includes(query);
        item.hidden = !visible;
        if (visible) visibleAccounts += 1;
      }
      if (accountSearchEmpty) accountSearchEmpty.hidden = !query || visibleAccounts > 0;
    };
    const clearFeed = () => {
      snapshots = [];
      list.replaceChildren();
      if (accountSearchEmpty) accountSearchEmpty.hidden = true;
    };
    const stopRequest = () => {
      generation += 1;
      request?.abort();
      request = null;
      resetRequest?.abort();
      resetRequest = null;
      presenceRequest?.abort();
      presenceRequest = null;
      clearTimeout(presenceRefreshTimer);
      presenceRefreshTimer = null;
      clearInterval(presenceTickTimer);
      presenceTickTimer = null;
      presenceState = null;
      presenceCheckedAt = 0;
      presenceReceivedAt = 0;
      activeAccountsRequest?.abort();
      activeAccountsRequest = null;
      scriptCommandRequest?.abort();
      scriptCommandRequest = null;
      clearTimeout(activeAccountsRefreshTimer);
      activeAccountsRefreshTimer = null;
      clearTimeout(scriptCommandCooldownTimer);
      scriptCommandCooldownTimer = null;
      scriptCommandCooldownUntil = 0;
      activeAccountsLoadVersion += 1;
      activeAccounts = [];
      activeAccountsLoading = false;
      activeAccountCount = 0;
      scriptCommandBusy = false;
      if (scriptCommandDialog.open) scriptCommandDialog.close();
      clearTimeout(resetCooldownTimer);
      resetCooldownTimer = null;
      resetAvailableAt = 0;
      resetServerOffset = 0;
      if (resetCooldownOutput) resetCooldownOutput.hidden = true;
      if (resetCountdownTime) resetCountdownTime.textContent = '';
      for (const button of scriptCommandOpeners) button.disabled = false;
      for (const button of scriptCommandActions) button.disabled = true;
      scriptTargetAllInput.checked = false;
      scriptTargetAllOption.hidden = true;
      scriptTargetAllCount.textContent = '0';
      scriptTargetPicker.disabled = true;
      connectedAccountList.replaceChildren();
      connectedAccountRefresh.disabled = false;
      connectedAccountRefreshLabel.textContent = labels.connected_accounts_refresh;
      killCommandLabel.textContent = labels.kill_roblox;
      restartCommandLabel.textContent = labels.restart_game;
      if (resetHwidButton) {
        resetHwidButton.disabled = false;
        resetHwidButton.removeAttribute('aria-disabled');
      }
      busy = false;
      verifying = false;
      clearTimeout(refreshTimer);
      clearTimeout(accessRetryTimer);
      accessRetryTimer = null;
      refresh.disabled = false;
      list.removeAttribute('aria-busy');
    };
    const stopPopup = () => {
      clearInterval(popupTimer);
      try { popup?.close(); } catch (_) {}
      popup = null;
      oauthState = null;
    };
    const showGate = (key = 'privacy', error = false) => {
      if (!token && key === 'unavailable') {
        key = 'privacy';
        error = false;
      }
      stopRequest();
      clearFeed();
      verifiedDiscordId = null;
      gate.hidden = false;
      selector.hidden = true;
      content.hidden = true;
      showPanelView('overview', false);
      const retryButton = qs('[data-discord-retry]');
      const loginButton = qs('[data-discord-login]');
      retryButton.hidden = false;
      loginButton.hidden = Boolean(token) && key === 'unavailable';
      authStatus(key, error);
      queueMicrotask(() => {
        const focusTarget = loginButton.hidden ? retryButton : loginButton;
        if (!page.hidden && !gate.hidden) focusTarget.focus();
      });
    };
    const scheduleAccessRetry = (seconds) => {
      clearTimeout(accessRetryTimer);
      accessRetryTimer = null;
      if (!token || !panelRequested || page.hidden || document.hidden) return;
      const version = generation;
      accessRetryTimer = setTimeout(() => {
        accessRetryTimer = null;
        if (version === generation && token && panelRequested && !page.hidden && !document.hidden) verifySession();
      }, Math.max(1, Math.ceil(seconds)) * 1000);
    };
    const recoverAccess = (error) => {
      const suggested = Number(error?.retryAfter);
      const seconds = Number.isFinite(suggested) && suggested > 0 ? Math.min(86400, suggested) : 60;
      showGate('unavailable', true);
      accessRetryUntil = Date.now() + Math.ceil(seconds) * 1000;
      scheduleAccessRetry(seconds);
    };
    const logout = () => {
      accessRetryUntil = 0;
      token = null;
      clearStoredToken();
      verifiedDiscordId = null;
      discordUser = null;
      resumePending = false;
      stopPopup();
      qsa('[data-discord-user-name]').forEach((el) => { el.textContent = 'Discord'; });
      qsa('[data-discord-user-avatar]').forEach((el) => { el.hidden = true; el.style.removeProperty('background-image'); });
      showGate();
    };
    const displayUser = (user) => {
      const name = user.global_name || user.username || 'Discord';
      discordUser = user;
      const avatarUrl = telemetry.discordAvatarUrl(user);
      qsa('[data-discord-user-name]').forEach((el) => { el.textContent = name; });
      qsa('.game-panel__discord-user small').forEach((el) => { el.textContent = labels.connected; });
      qsa('[data-discord-user-avatar]').forEach((el) => {
        el.hidden = !avatarUrl;
        if (avatarUrl) el.style.backgroundImage = `url("${avatarUrl}")`;
        else el.style.removeProperty('background-image');
      });
      qsa('[data-discord-user-fallback]').forEach((el) => {
        el.textContent = name.slice(0, 1).toUpperCase();
        el.hidden = Boolean(avatarUrl);
      });
      gate.hidden = true;
      selector.hidden = true;
      content.hidden = false;
      scheduleRefresh();
    };
    const failAuth = (code) => {
      accessRetryUntil = 0;
      token = null;
      clearStoredToken();
      resumePending = false;
      showGate(code === 'role_required' ? 'role_required' : code === 'reconnect_required' ? 'reconnect_required' : 'expired', true);
    };
    const reportAccessFailure = (stage, error) => {
      const code = ['session_expired', 'role_required', 'reconnect_required', 'discord_unavailable', 'rate_limited', 'access_unavailable'].includes(error?.code)
        ? error.code : error?.name === 'AbortError' ? 'timeout' : 'unavailable';
      console.warn('[Greamhub access] ' + JSON.stringify({ stage, status: Number.isInteger(error?.status) ? error.status : 0, code, upstream: ['authorization', 'discord_member'].includes(error?.retrySource) ? error.retrySource : null }));
    };
    const requestJson = async (query) => {
      if (!token || Date.now() >= token.expiresAt) throw Object.assign(new Error(), { code: 'session_expired', status: 401 });
      request = new AbortController();
      const current = request;
      const timeout = setTimeout(() => current.abort(), 15000);
      try {
        const response = await fetch(endpoint + query, {
          method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error',
          headers: { Authorization: `Bearer ${token.accessToken}` }, signal: current.signal
        });
        const data = await response.json();
        if (!response.ok) throw Object.assign(new Error(), { code: data.error, status: response.status, retryAfter: Number(response.headers.get('Retry-After')) });
        if (!data.ok || data.roleId !== roleId) throw new Error();
        return data;
      } finally {
        clearTimeout(timeout);
        if (request === current) request = null;
      }
    };
    const updatePresenceBadges = () => {
      const elapsed = presenceReceivedAt ? Math.max(0, performance.now() - presenceReceivedAt) : 0;
      for (const badge of list.querySelectorAll('[data-account-presence]')) {
        const userId = badge.dataset.userId;
        const account = presenceState instanceof Map ? presenceState.get(userId) : null;
        const age = account?.proofAt ? Math.max(0, presenceCheckedAt - account.proofAt) + elapsed : Infinity;
        const state = !userId || presenceState === 'unavailable' ? 'unknown'
          : presenceState === null ? 'checking'
          : account?.state === 'active' && age <= 45000 ? 'active'
          : account?.state === 'stopped' && age <= 45000 ? 'inactive' : 'unconfirmed';
        badge.dataset.presenceState = state;
        badge.textContent = labels['presence_' + (state === 'inactive' ? 'not_active' : state)] || labels.presence_unknown;
      }
    };
    const schedulePresenceRefresh = () => {
      clearTimeout(presenceRefreshTimer);
      presenceRefreshTimer = null;
      if (token && verifiedDiscordId && !page.hidden && !content.hidden && !document.hidden) {
        presenceRefreshTimer = setTimeout(loadPresence, 20000);
      }
    };
    const loadPresence = async () => {
      if (presenceRequest || !token || !verifiedDiscordId || page.hidden || content.hidden || document.hidden) return;
      clearTimeout(presenceRefreshTimer);
      presenceRefreshTimer = null;
      const version = generation;
      const current = new AbortController();
      presenceRequest = current;
      const timeout = setTimeout(() => current.abort(), 12000);
      if (!presenceTickTimer) presenceTickTimer = setInterval(updatePresenceBadges, 5000);
      try {
        if (Date.now() >= token.expiresAt) throw Object.assign(new Error(), { status: 401, code: 'session_expired' });
        const response = await fetch(endpoint + '?presence=1', {
          method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error',
          headers: { Authorization: `Bearer ${token.accessToken}` }, signal: current.signal
        });
        const data = await response.json();
        if (!response.ok) throw Object.assign(new Error(), { status: response.status, code: data.error });
        if (version !== generation) return;
        const checkedAt = Date.parse(data.checkedAt);
        if (!data.ok || data.roleId !== roleId || data.scope !== 'discord-user-presence'
            || data.ownerDiscordId !== verifiedDiscordId || !Number.isFinite(checkedAt)
            || !Array.isArray(data.accounts) || data.accounts.length > 500) throw new Error();
        const next = new Map();
        for (const account of data.accounts) {
          const id = account?.userId;
          const state = account?.state;
          const proofAt = Date.parse(state === 'active' ? account?.lastConfirmedAt
            : state === 'stopped' ? account?.lastStoppedAt : null);
          if (!/^[1-9]\d{0,19}$/.test(id || '') || next.has(id)
              || !['active', 'stopped', 'unknown'].includes(state)
              || (state !== 'unknown' && (!Number.isFinite(proofAt) || proofAt > checkedAt))) throw new Error();
          next.set(id, { state, proofAt: Number.isFinite(proofAt) ? proofAt : 0 });
        }
        presenceState = next;
        presenceCheckedAt = checkedAt;
        presenceReceivedAt = performance.now();
        updatePresenceBadges();
      } catch (error) {
        if (version !== generation) return;
        if ([401, 403].includes(error.status)) { failAuth(error.code); return; }
        presenceState = 'unavailable';
        updatePresenceBadges();
      } finally {
        clearTimeout(timeout);
        if (presenceRequest === current) presenceRequest = null;
        if (version === generation) schedulePresenceRefresh();
      }
    };
    const setScriptStatus = (key, tone) => {
      if (!scriptCommandStatus) return;
      scriptCommandStatus.textContent = !key || key === 'reset_hwid_cooldown' ? '' : labels[key] || labels.reset_hwid_unavailable;
      scriptCommandStatus.classList.remove('is-not-connected', 'is-pending', 'is-success', 'is-error');
      if (tone) scriptCommandStatus.classList.add(tone);
    };
    const formatResetRemaining = (totalSeconds) => {
      const seconds = Math.max(0, Math.ceil(totalSeconds));
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainder = seconds % 60;
      return [days ? `${days}d` : '', `${hours}h`, `${minutes}m`, `${remainder}s`].filter(Boolean).join(' ');
    };
    const clearResetCooldown = (announceReady = false) => {
      clearTimeout(resetCooldownTimer);
      resetCooldownTimer = null;
      resetAvailableAt = 0;
      resetServerOffset = 0;
      if (resetCooldownOutput) resetCooldownOutput.hidden = true;
      if (resetCountdownBefore) resetCountdownBefore.textContent = '';
      if (resetCountdownAfter) resetCountdownAfter.textContent = '';
      if (resetCountdownTime) {
        resetCountdownTime.textContent = '';
        resetCountdownTime.removeAttribute('datetime');
      }
      if (resetHwidButton) {
        resetHwidButton.disabled = false;
        resetHwidButton.removeAttribute('aria-disabled');
      }
      if (announceReady) setScriptStatus('reset_hwid_ready', 'is-success');
    };
    const renderResetCooldown = () => {
      clearTimeout(resetCooldownTimer);
      resetCooldownTimer = null;
      if (!resetAvailableAt || !resetCooldownOutput || !resetCountdownTime) return;
      const remainingSeconds = Math.ceil((resetAvailableAt - (Date.now() + resetServerOffset)) / 1000);
      if (remainingSeconds <= 0) {
        clearResetCooldown(true);
        return;
      }
      resetCountdownTime.textContent = formatResetRemaining(remainingSeconds);
      resetCooldownTimer = setTimeout(renderResetCooldown, 1000);
    };
    const applyResetCooldown = (data) => {
      const serverNow = Number(data?.serverNow);
      const nextAllowedAt = Number(data?.nextAllowedAt);
      if (!Number.isSafeInteger(serverNow) || !Number.isSafeInteger(nextAllowedAt)
          || serverNow < 0 || nextAllowedAt <= serverNow
          || nextAllowedAt - serverNow > 10 * 365 * 24 * 60 * 60 * 1000
          || !resetCooldownOutput || !resetCountdownTime) {
        clearResetCooldown(false);
        return false;
      }
      const template = labels.reset_hwid_cooldown_remaining || '{time}';
      const marker = template.indexOf('{time}');
      if (resetCountdownBefore) resetCountdownBefore.textContent = marker >= 0 ? template.slice(0, marker) : '';
      if (resetCountdownAfter) resetCountdownAfter.textContent = marker >= 0 ? template.slice(marker + 6) : '';
      resetCountdownTime.setAttribute('datetime', new Date(nextAllowedAt).toISOString());
      resetServerOffset = serverNow - Date.now();
      resetAvailableAt = nextAllowedAt;
      resetCooldownOutput.hidden = false;
      if (resetHwidButton) {
        resetHwidButton.disabled = false;
        resetHwidButton.setAttribute('aria-disabled', 'true');
      }
      renderResetCooldown();
      return true;
    };
    const resetJson = async (method, query = '', body = null) => {
      if (!token || Date.now() >= token.expiresAt) {
        throw Object.assign(new Error(), { code: 'session_expired', status: 401 });
      }
      resetRequest?.abort();
      const current = new AbortController();
      resetRequest = current;
      const timeout = setTimeout(() => current.abort(), 15000);
      try {
        const headers = { Authorization: `Bearer ${token.accessToken}` };
        if (body) headers['Content-Type'] = 'application/json';
        const response = await fetch(resetEndpoint + query, {
          method, mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error',
          headers, body: body ? JSON.stringify(body) : undefined, signal: current.signal
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw Object.assign(new Error(), {
          code: data.error,
          status: response.status,
          serverNow: data.serverNow,
          nextAllowedAt: data.nextAllowedAt,
          remainingSeconds: data.remainingSeconds
        });
        if (!data.ok || data.roleId !== roleId) throw new Error();
        return data;
      } finally {
        clearTimeout(timeout);
        if (resetRequest === current) resetRequest = null;
      }
    };
    const syncResetCooldown = async () => {
      if (!resetHwidButton || !verifiedDiscordId || !token) return;
      const version = generation;
      try {
        const result = await resetJson('GET', '?state=1');
        if (version !== generation) return;
        if (applyResetCooldown(result)) setScriptStatus('reset_hwid_cooldown', 'is-error');
        else clearResetCooldown(false);
      } catch (error) {
        if (version !== generation) return;
        if ([401, 403].includes(error.status)) failAuth(error.code);
      }
    };
    const scriptCommandStatusKeys = {
      kill_roblox: {
        all: { pending: 'kill_roblox_pending', success: 'kill_roblox_success' },
        player: { pending: 'kill_roblox_selected_pending', success: 'kill_roblox_selected_success' }
      },
      restart_game: {
        all: { pending: 'restart_game_pending', success: 'restart_game_success' },
        player: { pending: 'restart_game_selected_pending', success: 'restart_game_selected_success' }
      }

    };
    const setScriptDialogStatus = (key = '', tone = '', text = '') => {
      if (!scriptDialogStatus) return;
      scriptDialogStatus.textContent = text || (key ? labels[key] || labels.script_command_failed : '');
      scriptDialogStatus.dataset.state = key;
      scriptDialogStatus.classList.remove('is-pending', 'is-success', 'is-error');
      if (tone) scriptDialogStatus.classList.add(tone);
    };
    const getSelectedScriptTarget = () => {
      if (scriptTargetAllInput.checked && activeAccounts.length > 0) return { scope: 'all' };
      const input = connectedAccountList.querySelector('[data-script-target-player]:checked');
      const requestedPlayer = input?.dataset.scriptTargetPlayer?.trim();
      if (!requestedPlayer) return null;
      const account = activeAccounts.find((item) => item.player.toLowerCase() === requestedPlayer.toLowerCase());
      return account ? { scope: 'player', player: account.player } : null;
    };
    const syncScriptCommandButtons = () => {
      const target = getSelectedScriptTarget();
      const coolingDown = scriptCommandCooldownUntil > Date.now();
      scriptTargetPicker.disabled = scriptCommandBusy || activeAccountsLoading || activeAccountCount < 1;
      connectedAccountRefresh.disabled = scriptCommandBusy || activeAccountsLoading;
      connectedAccountSearch.disabled = scriptCommandBusy || activeAccountsLoading || activeAccountCount < 1;
      connectedAccountRefreshLabel.textContent = activeAccountsLoading
        ? labels.connected_accounts_refreshing : labels.connected_accounts_refresh;
      killCommandLabel.textContent = target?.scope === 'all'
        ? labels.kill_all : target?.scope === 'player' ? labels.kill_selected : labels.kill_roblox;
      restartCommandLabel.textContent = target?.scope === 'all'
        ? labels.restart_all : target?.scope === 'player' ? labels.restart_selected : labels.restart_game;
      for (const button of scriptCommandActions) {
        button.disabled = scriptCommandBusy || activeAccountsLoading || coolingDown || !target;
      }
    };
    const applyConnectedAccountSearch = () => {
      const query = searchable(connectedAccountSearch.value);
      let visibleAccounts = 0;
      let selectionHidden = false;
      for (const item of connectedAccountList.querySelectorAll(':scope > .script-command-dialog__account-item')) {
        const visible = !query || searchable(item.dataset.connectedAccountSearch).includes(query);
        item.hidden = !visible;
        const input = item.querySelector('[data-script-target-player]');
        if (!visible && input?.checked) {
          input.checked = false;
          selectionHidden = true;
        }
        if (visible) visibleAccounts += 1;
      }
      if (query && scriptTargetAllInput.checked) {
        scriptTargetAllInput.checked = false;
        selectionHidden = true;
      }
      scriptTargetAllOption.hidden = activeAccounts.length < 1;
      connectedAccountSearchEmpty.hidden = !query || activeAccountsLoading || visibleAccounts > 0;
      if (selectionHidden && scriptDialogStatus?.dataset.state !== 'script_command_cooldown') setScriptDialogStatus();
      syncScriptCommandButtons();
    };
    const clearScriptTargetSelection = (statusKey = '') => {
      for (const input of scriptTargetPicker.querySelectorAll('input[type="radio"]')) input.checked = false;
      if (statusKey) setScriptDialogStatus(statusKey, 'is-error');
      syncScriptCommandButtons();
    };
    const setScriptCommandBusy = (value) => {
      scriptCommandBusy = Boolean(value);
      for (const button of scriptCommandOpeners) button.disabled = scriptCommandBusy;
      syncScriptCommandButtons();
    };
    const scheduleScriptCommandCooldown = () => {
      clearTimeout(scriptCommandCooldownTimer);
      scriptCommandCooldownTimer = null;
      const remaining = scriptCommandCooldownUntil - Date.now();
      if (remaining <= 0) {
        scriptCommandCooldownUntil = 0;
        if (scriptDialogStatus?.dataset.state === 'script_command_cooldown') setScriptDialogStatus();
        syncScriptCommandButtons();
        return;
      }
      const seconds = Math.max(1, Math.ceil(remaining / 1000));
      const template = labels.script_command_cooldown_remaining || labels.script_command_cooldown;
      if (scriptCommandDialog.open) {
        setScriptDialogStatus('script_command_cooldown', 'is-error', template.replace('[[seconds]]', String(seconds)));
      }
      syncScriptCommandButtons();
      scriptCommandCooldownTimer = setTimeout(scheduleScriptCommandCooldown, Math.min(1000, remaining));
    };
    const applyScriptCommandCooldown = (seconds) => {
      const boundedSeconds = Math.min(30, Math.max(1, Math.ceil(Number(seconds) || 5)));
      scriptCommandCooldownUntil = Date.now() + boundedSeconds * 1000;
      scheduleScriptCommandCooldown();
    };
    const renderConnectedAccountState = (key, tone = '') => {
      activeAccounts = [];
      activeAccountsLoading = key === 'connected_accounts_loading';
      activeAccountCount = 0;
      connectedAccountList.replaceChildren();
      connectedAccountSearchEmpty.hidden = true;
      connectedAccountCount.textContent = '0';
      scriptTargetAllCount.textContent = '0';
      scriptTargetAllOption.hidden = true;
      scriptTargetAllInput.checked = false;
      connectedAccountStatus.textContent = labels[key] || labels.connected_accounts_error;
      connectedAccountStatus.classList.toggle('is-error', tone === 'is-error');
      connectedAccountSection?.setAttribute('aria-busy', activeAccountsLoading ? 'true' : 'false');
      syncScriptCommandButtons();
    };
    const setConnectedAccountsLoading = () => {
      activeAccountsLoading = true;
      connectedAccountStatus.textContent = labels.connected_accounts_loading;
      connectedAccountStatus.classList.remove('is-error');
      connectedAccountSection?.setAttribute('aria-busy', 'true');
      connectedAccountSearchEmpty.hidden = true;
      syncScriptCommandButtons();
    };
    const renderConnectedAccounts = (data) => {
      const previousTarget = getSelectedScriptTarget();
      const checkedAt = Date.parse(data?.checkedAt);
      if (!Number.isFinite(checkedAt) || data?.activeWindowSeconds !== 3600 || !Array.isArray(data?.accounts)
          || data.accounts.length > 25) throw new Error();
      const seenPlayers = new Set();
      const accounts = data.accounts.map((account) => {
        const player = typeof account?.player === 'string' ? account.player.trim() : '';
        const lastSeenAt = typeof account?.lastSeenAt === 'string' ? account.lastSeenAt : '';
        const timestamp = Date.parse(lastSeenAt);
        const normalizedPlayer = player.toLowerCase();
        if (!/^[A-Za-z0-9_]{3,20}$/.test(player) || seenPlayers.has(normalizedPlayer) || !Number.isFinite(timestamp)
            || timestamp > checkedAt || checkedAt - timestamp >= data.activeWindowSeconds * 1000) throw new Error();
        seenPlayers.add(normalizedPlayer);
        return { player, lastSeenAt, timestamp };
      });
      connectedAccountList.replaceChildren();
      const playerInputs = new Map();
      for (const account of accounts) {
        const item = document.createElement('li');
        item.className = 'script-command-dialog__account-item';
        item.dataset.connectedAccountSearch = account.player;
        const option = document.createElement('label');
        option.className = 'script-command-dialog__target script-command-dialog__target--account';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = scriptTargetAllInput.name;
        input.value = 'player';
        input.dataset.scriptTargetPlayer = account.player;
        input.setAttribute('aria-describedby', scriptTargetAllInput.getAttribute('aria-describedby'));
        const presence = document.createElement('span');
        presence.className = 'script-command-dialog__presence';
        presence.setAttribute('aria-hidden', 'true');
        const copy = document.createElement('span');
        copy.className = 'script-command-dialog__target-copy';
        const player = document.createElement('strong');
        player.textContent = account.player;
        copy.append(player);
        const meta = document.createElement('span');
        meta.className = 'script-command-dialog__account-meta';
        const label = document.createElement('span');
        label.textContent = labels.last_seen;
        const time = document.createElement('time');
        time.dateTime = new Date(account.timestamp).toISOString();
        time.textContent = formatTime(account.lastSeenAt);
        meta.append(label, time);
        option.append(input, presence, copy, meta);
        item.append(option);
        connectedAccountList.append(item);
        playerInputs.set(account.player.toLowerCase(), input);
      }
      activeAccounts = accounts;
      activeAccountsLoading = false;
      activeAccountCount = accounts.length;
      connectedAccountCount.textContent = String(accounts.length);
      scriptTargetAllCount.textContent = String(accounts.length);
      scriptTargetAllOption.hidden = accounts.length < 1;
      scriptTargetAllInput.checked = previousTarget?.scope === 'all' && accounts.length > 0;
      const preservedPlayerInput = previousTarget?.scope === 'player'
        ? playerInputs.get(previousTarget.player.toLowerCase()) : null;
      if (preservedPlayerInput) preservedPlayerInput.checked = true;
      const selectionDisappeared = previousTarget?.scope === 'player' && !preservedPlayerInput;
      connectedAccountStatus.textContent = accounts.length ? '' : labels.connected_accounts_empty;
      connectedAccountStatus.classList.remove('is-error');
      connectedAccountSection?.setAttribute('aria-busy', 'false');
      if (selectionDisappeared) setScriptDialogStatus('target_no_longer_active', 'is-error');
      applyConnectedAccountSearch();
    };
    const scriptControlJson = async (method, body = null) => {
      if (!token || Date.now() >= token.expiresAt) {
        throw Object.assign(new Error(), { code: 'session_expired', status: 401 });
      }
      const isAccountList = method === 'GET';
      const previous = isAccountList ? activeAccountsRequest : scriptCommandRequest;
      previous?.abort();
      const current = new AbortController();
      if (isAccountList) activeAccountsRequest = current;
      else scriptCommandRequest = current;
      const timeout = setTimeout(() => current.abort(), 15000);
      try {
        const headers = { Authorization: `Bearer ${token.accessToken}` };
        if (body) headers['Content-Type'] = 'application/json';
        const response = await fetch(scriptControlEndpoint, {
          method, mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error', headers,
          body: body ? JSON.stringify(body) : undefined, signal: current.signal
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw Object.assign(new Error(), {
          code: data.error,
          status: response.status,
          retryAfter: response.headers.get('retry-after')
        });
        if (!data.ok || data.roleId !== roleId) throw new Error();
        return data;
      } finally {
        clearTimeout(timeout);
        if (isAccountList && activeAccountsRequest === current) activeAccountsRequest = null;
        if (!isAccountList && scriptCommandRequest === current) scriptCommandRequest = null;
      }
    };
    const scheduleActiveAccountsRefresh = () => {
      clearTimeout(activeAccountsRefreshTimer);
      activeAccountsRefreshTimer = null;
      if (scriptCommandDialog.open && token && !page.hidden && !document.hidden) {
        activeAccountsRefreshTimer = setTimeout(loadActiveAccounts, 60000);
      }
    };
    const loadActiveAccounts = async () => {
      if (!scriptCommandDialog.open || !verifiedDiscordId || !token) return;
      const version = generation;
      const loadVersion = ++activeAccountsLoadVersion;
      setConnectedAccountsLoading();
      try {
        const result = await scriptControlJson('GET');
        if (version !== generation || loadVersion !== activeAccountsLoadVersion || !scriptCommandDialog.open) return;
        renderConnectedAccounts(result);
      } catch (error) {
        if (version !== generation || loadVersion !== activeAccountsLoadVersion || !scriptCommandDialog.open) return;
        if ([401, 403].includes(error.status)) failAuth(error.code);
        else renderConnectedAccountState('connected_accounts_error', 'is-error');
      } finally {
        if (version === generation && loadVersion === activeAccountsLoadVersion) scheduleActiveAccountsRefresh();
      }
    };
    const openScriptCommandDialog = () => {
      if (!killRobloxButton || !verifiedDiscordId || !token || scriptCommandDialog.open) return;
      setScriptDialogStatus();
      connectedAccountSearch.value = '';
      connectedAccountSearchEmpty.hidden = true;
      renderConnectedAccountState('connected_accounts_loading');
      scriptCommandDialog.showModal();
      scheduleScriptCommandCooldown();
      loadActiveAccounts();
    };
    const closeScriptCommandDialog = () => {
      if (scriptCommandDialog.open) scriptCommandDialog.close();
    };
    const commandResultKeys = {
      shutdown_requested: 'script_result_shutdown_requested', shutdown_failed: 'script_result_shutdown_failed',
      completed: 'script_result_completed'
    };
    const commandResultCodes = {
      kill_roblox: ['shutdown_requested', 'shutdown_failed'], restart_game: ['completed']
    };
    const waitForScriptResult = async (action, receipts, version) => {
      const completed = new Map();
      const ids = receipts.map((receipt) => receipt.messageId);
      const current = new AbortController();
      scriptCommandRequest = current;
      const limit = setTimeout(() => current.abort(), 90000);
      const active = () => version === generation && scriptCommandDialog.open && !current.signal.aborted;
      const pause = () => new Promise((resolve) => {
        let timer;
        const finish = () => { clearTimeout(timer); current.signal.removeEventListener('abort', finish); resolve(); };
        timer = setTimeout(finish, 3000);
        current.signal.addEventListener('abort', finish, {once: true});
        if (current.signal.aborted) finish();
      });
      try {
        while (active()) {
          await pause();
          if (!active()) return;
          if (!token || Date.now() >= token.expiresAt) throw Object.assign(new Error(), {status: 401, code: 'session_expired'});
          const response = await fetch(`${apiOrigin}/discord/messages?command_results=${encodeURIComponent(ids.join(','))}`, {
            method: 'GET', credentials: 'omit', cache: 'no-store', redirect: 'error',
            headers: {Authorization: `Bearer ${token.accessToken}`}, signal: current.signal
          });
          const data = await response.json().catch(() => ({}));
          if (!active()) return;
          if ([401, 403].includes(response.status)) throw Object.assign(new Error(), {status: response.status, code: data.error});
          if (!response.ok) continue;
          if (!data.ok || data.roleId !== roleId || !Array.isArray(data.results) || data.results.length !== ids.length) throw new Error();
          const seen = new Set();
          for (const result of data.results) {
            const expected = receipts.find((item) => item.messageId === result.messageId);
            if (!expected || seen.has(result.messageId) || !['pending', 'completed'].includes(result.status)) throw new Error();
            seen.add(result.messageId);
            if (result.status !== 'completed') continue;
            if (result.player !== expected.player || !commandResultCodes[action].includes(result.code)) throw new Error();
            completed.set(result.messageId, result);
          }
          const lines = receipts.map((item) => {
            const result = completed.get(item.messageId);
            const message = labels[result ? commandResultKeys[result.code] : 'script_result_waiting'];
            return receipts.length === 1 ? message : `${item.player} : ${message}`;
          });
          const allDone = completed.size === receipts.length;
          const failed = [...completed.values()].some((result) => result.code === 'shutdown_failed');
          const tone = !allDone ? 'is-pending' : failed ? 'is-error' : 'is-success';
          setScriptDialogStatus(null, tone, lines.join('\n'));
          setScriptStatus('script_result_waiting', tone);
          if (scriptCommandStatus) scriptCommandStatus.textContent = lines.join('\n');
          if (allDone) return;
        }
      } catch (error) {
        if (version !== generation || !scriptCommandDialog.open) return;
        if (!current.signal.aborted) throw error;
      } finally {
        clearTimeout(limit);
        if (scriptCommandRequest === current) scriptCommandRequest = null;
        if (version === generation && scriptCommandDialog.open && current.signal.aborted) {
          const lines = receipts.map((item) => {
            const result = completed.get(item.messageId);
            const message = labels[result ? commandResultKeys[result.code] : 'script_result_timeout'];
            return receipts.length === 1 ? message : `${item.player} : ${message}`;
          });
          setScriptDialogStatus(null, 'is-pending', lines.join('\n'));
          setScriptStatus('script_result_timeout', 'is-pending');
          if (scriptCommandStatus) scriptCommandStatus.textContent = lines.join('\n');
        }
      }
    };

    const runScriptCommand = async (action) => {
      const target = getSelectedScriptTarget();
      const statuses = target ? scriptCommandStatusKeys[action]?.[target.scope] : null;
      if (!target) {
        setScriptDialogStatus('target_selection_required', 'is-error');
        return;
      }
      if (!statuses || !verifiedDiscordId || !token || scriptCommandBusy || activeAccountsLoading
          || scriptCommandCooldownUntil > Date.now() || activeAccountCount < 1) return;
      const version = generation;
      setScriptCommandBusy(true);
      setScriptStatus(statuses.pending, 'is-pending');
      setScriptDialogStatus(statuses.pending, 'is-pending');
      try {
        const result = await scriptControlJson('POST', { action, target });
        if (version !== generation) return;
        if (result.action !== action || !Number.isSafeInteger(result.affectedCount) || result.affectedCount < 1
            || result.affectedCount > 25 || (target.scope === 'player' && result.affectedCount !== 1)) throw new Error();
        if (!Array.isArray(result.receipts) || result.receipts.length !== result.affectedCount
            || new Set(result.receipts.map((item) => item.messageId)).size !== result.receipts.length
            || result.receipts.some((item) => !/^\d{17,20}$/.test(item.messageId || '')
              || typeof item.player !== 'string' || !/^[A-Za-z0-9_]{3,20}$/.test(item.player))) throw new Error();
        setScriptStatus('script_result_waiting', 'is-pending');
        setScriptDialogStatus('script_result_waiting', 'is-pending');
        await waitForScriptResult(action, result.receipts, version);
      } catch (error) {
        if (version !== generation) return;
        if ([401, 403].includes(error.status)) {
          failAuth(error.code);
        } else if (error.status === 429 && error.code === 'control_cooldown') {
          applyScriptCommandCooldown(error.retryAfter);
          setScriptStatus('script_command_cooldown', 'is-error');
        } else if (error.code === 'invalid_control_target') {
          clearScriptTargetSelection('target_no_longer_active');
          setScriptStatus('script_command_failed', 'is-error');
          loadActiveAccounts();
        } else {
          const statusKey = 'script_command_failed';
          if (error.code === 'no_active_accounts') renderConnectedAccountState('connected_accounts_empty');
          setScriptStatus(statusKey, 'is-error');
          setScriptDialogStatus(statusKey, 'is-error');
        }
      } finally {
        if (version === generation) setScriptCommandBusy(false);
      }
    };
    const runHwidReset = async () => {
      if (!resetHwidButton || resetHwidButton.disabled || !verifiedDiscordId || !token) return;
      if (resetAvailableAt > Date.now() + resetServerOffset) {
        renderResetCooldown();
        return;
      }
      const version = generation;
      resetHwidButton.disabled = true;
      setScriptStatus('reset_hwid_pending', 'is-pending');
      try {
        let result = await resetJson('POST', '', {});
        for (let attempt = 0; attempt < 60 && ['pending', 'claimed'].includes(result.status); attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 1200));
          if (version !== generation) return;
          result = await resetJson('GET', `?job=${encodeURIComponent(result.jobId)}`);
        }
        if (version !== generation) return;
        if (result.status === 'succeeded') {
          setScriptStatus('reset_hwid_success', 'is-success');
          if (!applyResetCooldown(result)) resetHwidButton.disabled = false;
        } else if (result.status === 'failed' && result.error === 'reset_cooldown') {
          setScriptStatus('reset_hwid_cooldown', 'is-error');
          if (!applyResetCooldown(result)) resetHwidButton.disabled = false;
        } else if (result.status === 'failed') {
          resetHwidButton.disabled = false;
          setScriptStatus(result.error === 'user_not_found' ? 'reset_hwid_unlinked' : 'reset_hwid_failed', 'is-error');
        } else {
          resetHwidButton.disabled = false;
          setScriptStatus('reset_hwid_processing', 'is-pending');
        }
      } catch (error) {
        if (version !== generation) return;
        if ([401, 403].includes(error.status)) {
          failAuth(error.code);
        } else if (error.status === 429 && error.code === 'reset_cooldown') {
          setScriptStatus('reset_hwid_cooldown', 'is-error');
          if (!applyResetCooldown(error)) resetHwidButton.disabled = false;
        } else {
          resetHwidButton.disabled = false;
          setScriptStatus('reset_hwid_unavailable', 'is-error');
        }
      }
    };
    const verifySession = async () => {
      if (verifying || !token || !panelRequested || page.hidden || document.hidden) return;
      if (accessRetryUntil > Date.now()) {
        scheduleAccessRetry((accessRetryUntil - Date.now()) / 1000);
        return;
      }
      stopRequest();
      clearFeed();
      gate.hidden = false;
      selector.hidden = true;
      content.hidden = true;
      qs('[data-discord-login]').hidden = true;
      qs('[data-discord-retry]').hidden = true;
      authStatus('checking');
      feedStatus.textContent = labels.checking;
      list.setAttribute('aria-busy', 'true');
      verifying = true;
      busy = true;
      const version = generation;
      try {
        const result = await requestJson('?check=1');
        if (version !== generation) return;
        if (!/^\d{17,20}$/.test(result.user?.id || '')) throw new Error();
        verifiedDiscordId = result.user.id;
        displayUser(result.user);
        busy = false;
        await loadMessages();
        if (version === generation) await syncResetCooldown();
      } catch (error) {
        if (version !== generation) return;
        reportAccessFailure('profile', error);
        if ([401, 403].includes(error.status)) failAuth(error.code);
        else recoverAccess(error);
      } finally {
        if (version === generation) {
          verifying = false;
          busy = false;
          list.removeAttribute('aria-busy');
          scheduleRefresh();
        }
      }
    };
    const suspendPage = () => {
      if (token && panelRequested && !page.hidden) resumePending = true;
      stopRequest();
      clearFeed();
    };
    const resumePage = () => {
      if (!resumePending || !token || page.hidden || document.hidden) return;
      resumePending = false;
      return verifySession(true);
    };
    const formatTime = (value) => {
      const date = new Date(value);
      return Number.isFinite(date.getTime()) ? date.toLocaleString(shell.lang || 'en') : '';
    };
    const scheduleRefresh = (delay = 300000) => {
      clearTimeout(refreshTimer);
      if (token && !page.hidden && gate.hidden && !document.hidden) {
        refreshTimer = setTimeout(() => !content.hidden ? loadMessages() : checkAccess(), delay);
      }
    };
    const checkAccess = async () => {
      if (busy || !token || page.hidden || document.hidden) return;
      busy = true;
      const version = generation;
      try {
        const result = await requestJson('?check=1');
        if (!verifiedDiscordId || result.user?.id !== verifiedDiscordId) throw new Error();
      } catch (error) {
        if (version !== generation) return;
        if ([401, 403].includes(error.status)) failAuth(error.code);
        else if (verifiedDiscordId) scheduleRefresh(60000);
        else recoverAccess(error);
      } finally {
        if (version === generation) { busy = false; scheduleRefresh(); }
      }
    };
    const loadMessages = async () => {
      if (busy || page.hidden || content.hidden || !token) return;
      busy = true;
      const version = generation;
      clearTimeout(refreshTimer);
      refresh.disabled = true;
      list.setAttribute('aria-busy', 'true');
      feedStatus.textContent = telemetryLabels.loading;
      let retryDelay = 15000;
      try {
        const data = await requestJson('?history=1&limit=25');
        if (version !== generation) return;
        if (!verifiedDiscordId || data.scope !== 'discord-user-history'
            || (data.ownerDiscordId && data.ownerDiscordId !== verifiedDiscordId) || data.channelId !== channelId
            || !Array.isArray(data.items) || data.items.length > 25
            || data.items.some((item) => !item || !/^\d{17,20}$/.test(item.id))) throw new Error();
        snapshots = telemetry.collect(data.items, [], verifiedDiscordId, true);
        const summaryNode = telemetry.renderSummary(data.summary);
        if (summaryNode === undefined) throw new Error();
        list.replaceChildren(...(summaryNode ? [summaryNode] : []), ...snapshots.map(telemetry.render));
        updatePresenceBadges();
        void loadPresence();
        applyAccountSearch();
        feedStatus.textContent = snapshots.length
          ? telemetryLabels.synced + ' · ' + formatTime(data.checkedAt)
          : telemetryLabels.empty;
      } catch (error) {
        if (version !== generation) return;
        reportAccessFailure('messages', error);
        if ([401, 403].includes(error.status)) { failAuth(error.code); return; }
        if (snapshots.length) {
          feedStatus.textContent = labels.unavailable;
          retryDelay = 60000;
          return;
        }
        clearFeed();
        recoverAccess(error);
        retryDelay = 60000;
      } finally {
        if (version === generation) {
          busy = false;
          refresh.disabled = false;
          list.removeAttribute('aria-busy');
          scheduleRefresh(retryDelay);
        }
      }
    };
    const isPanelUrl = (url) => url.pathname.replace(/\/+$/, '') === '/panel'
      || url.searchParams.get('panel') === 'greamwar';
    const openPage = (push = true) => {
      if (!panelRequested) return;
      page.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('purchase-panel-open');
      const url = new URL(location.href);
      const shouldPush = push && !isPanelUrl(url);
      url.pathname = '/panel';
      url.searchParams.delete('panel');
      url.hash = '';
      const panelUrl = url.pathname + url.search;
      if (shouldPush) {
        history.pushState({ greamwarPanel: true }, '', panelUrl);
        historyPushed = true;
      } else {
        history.replaceState({ ...history.state, greamwarPanel: true }, '', panelUrl);
      }
      document.querySelector('link[rel="canonical"]').href = url.origin + '/panel';
    };
    const closePage = (navigate = true) => {
      stopPopup();
      stopRequest();
      clearFeed();
      page.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('purchase-panel-open');
      if (navigate && historyPushed) history.back();
      else if (navigate) {
        const url = new URL(location.href);
        url.pathname = '/';
        url.searchParams.delete('panel');
        url.hash = '';
        history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
      document.querySelector('link[rel="canonical"]').href = location.origin + '/';
      historyPushed = false;
      opener.focus();
    };
    listen(opener, 'click', () => { panelRequested = true; openPage(); token ? verifySession(true) : showGate(); });
    listen(qs('[data-purchase-panel-close]'), 'click', () => closePage());
    listen(document, 'keydown', (event) => {
      if (event.key === 'Escape' && !page.hidden && !scriptCommandDialog.open) closePage();
    });
    listen(qs('[data-discord-logout]'), 'click', logout);
    listen(qs('[data-discord-retry]'), 'click', () => token ? verifySession(true) : showGate());
    for (const card of qsa('[data-game-select]')) listen(card, 'click', () => {
      if (!token) { showGate(); return; }
      qs('[data-selected-game-short]').textContent = card.dataset.gameTitle || defaultGameTitle;
      qs('[data-selected-game-name]').textContent = `${(card.dataset.gameTitle || defaultGameTitle).toUpperCase()} / ROBLOX`;
      selector.hidden = true;
      content.hidden = false;
      showPanelView('overview', false);
      loadMessages();
      page.scrollTo({ top: 0, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    listen(refresh, 'click', loadMessages);
    listen(accountSearch, 'input', applyAccountSearch);
    listen(overviewNav, 'click', () => showPanelView('overview'));
    listen(scriptNav, 'click', () => showPanelView('script'));
    for (const button of scriptCommandOpeners) listen(button, 'click', openScriptCommandDialog);
    listen(scriptCommandClose, 'click', closeScriptCommandDialog);
    listen(scriptCommandDialog, 'click', (event) => {
      if (event.target === scriptCommandDialog) closeScriptCommandDialog();
    });
    listen(connectedAccountRefresh, 'click', loadActiveAccounts);
    listen(connectedAccountSearch, 'input', applyConnectedAccountSearch);
    listen(scriptTargetPicker, 'change', (event) => {
      if (!event.target.matches?.('input[type="radio"]')) return;
      if (scriptDialogStatus?.dataset.state !== 'script_command_cooldown') setScriptDialogStatus();
      syncScriptCommandButtons();
    });
    listen(scriptCommandDialog, 'close', () => {
      scriptCommandRequest?.abort();
      scriptCommandRequest = null;
      clearTimeout(activeAccountsRefreshTimer);
      activeAccountsRefreshTimer = null;
      clearTimeout(scriptCommandCooldownTimer);
      scriptCommandCooldownTimer = null;
      activeAccountsLoadVersion += 1;
      activeAccountsRequest?.abort();
      activeAccountsRequest = null;
      activeAccounts = [];
      activeAccountsLoading = false;
      activeAccountCount = 0;
      connectedAccountSearch.value = '';
      connectedAccountSearchEmpty.hidden = true;
      connectedAccountList.replaceChildren();
      connectedAccountCount.textContent = '0';
      scriptTargetAllCount.textContent = '0';
      scriptTargetAllOption.hidden = true;
      clearScriptTargetSelection();
      scriptTargetPicker.disabled = true;
    });
    for (const button of scriptCommandActions) {
      listen(button, 'click', () => runScriptCommand(button.dataset.scriptCommandAction));
    }
    listen(resetHwidButton, 'click', runHwidReset);
    listen(document, 'visibilitychange', () => {
      if (document.hidden) suspendPage();
      else return resumePage();
    });
    listen(window, 'popstate', (event) => {
      if (isPanelUrl(new URL(location.href))) {
        panelRequested = true;
        openPage(false); token ? verifySession(true) : showGate();
      } else closePage(false);
    });
    listen(window, 'pagehide', (event) => {
      stopPopup();
      suspendPage();
      if (!event.persisted) {
        token = null;
        verifiedDiscordId = null;
        resumePending = false;
      }
    });
    listen(window, 'pageshow', (event) => {
      if (event.persisted) return resumePage();
    });
    listen(window, 'message', async (event) => {
      if (!popup || event.source !== popup || !storefrontOrigins.includes(event.origin) || event.data?.kind !== 'greamwar-discord-oauth'
          || typeof event.data.fragment !== 'string' || event.data.fragment.length > 4096) return;
      const params = new URLSearchParams(event.data.fragment.replace(/^#/, ''));
      if (!oauthState || params.get('state') !== oauthState) return;
      const accessToken = params.get('access_token');
      const expiresIn = Number(params.get('expires_in'));
      const scopes = (params.get('scope') || '').split(' ');
      stopPopup();
      if (params.get('error')) { authStatus('cancelled', true); return; }
      if (!/^[A-Za-z0-9._~+\/=\-]{20,512}$/.test(accessToken || '') || params.get('token_type')?.toLowerCase() !== 'bearer'
          || !Number.isFinite(expiresIn) || expiresIn <= 60 || expiresIn > 604800
          || !['identify', 'guilds.members.read'].every((scope) => scopes.includes(scope))) {
        authStatus('reconnect_required', true); return;
      }
      token = { accessToken, expiresAt: Date.now() + (expiresIn - 60) * 1000 };
      storeToken(token);
      if (document.hidden) { resumePending = true; return; }
      await verifySession();
    });
    listen(qs('[data-discord-login]'), 'click', () => {
      if (!panelRequested || page.hidden) return;
      if (!/^\d{17,20}$/.test(clientId || '') || !storefrontOrigins.includes(location.origin)) {
        authStatus('not_configured', true); return;
      }
      logout();
      const values = crypto.getRandomValues(new Uint8Array(24));
      oauthState = [...values].map((n) => n.toString(16).padStart(2, '0')).join('');
      const url = new URL('https://discord.com/oauth2/authorize');
      url.search = new URLSearchParams({ client_id: clientId, response_type: 'token', redirect_uri: redirectUri,
        scope: 'identify guilds.members.read', state: oauthState, prompt: 'consent' }).toString();
      popup = window.open(url.href, `greamwar-${oauthState}`, 'popup,width=520,height=760');
      if (!popup) { stopPopup(); authStatus('popup_blocked', true); return; }
      authStatus('waiting');
      const deadline = Date.now() + 300000;
      popupTimer = setInterval(() => {
        if (!popup || popup.closed || Date.now() > deadline) { stopPopup(); authStatus('cancelled', true); }
      }, 1000);
    });
    controllers.set(shell, () => { logout(); lifetime.abort(); controllers.delete(shell); });
    const initialUrl = new URL(location.href);
    const resumeAfterLanguage = isPanelUrl(initialUrl) && languageReturnStage;
    const openAfterMenu = isPanelUrl(initialUrl) && menuOpenRequested;
    if (resumeAfterLanguage || openAfterMenu || isPanelUrl(initialUrl)) {
      panelRequested = true;
      openPage(false);
      if (token) verifySession(true);
      else showGate();
    } else {
      page.hidden = true;
      document.body.classList.remove('purchase-panel-open');
      showGate();
    }
  };
  const scan = (root) => {
    if (root.matches?.('[data-purchase-panel-shell]')) init(root);
    root.querySelectorAll('[data-purchase-panel-shell]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [shell, dispose] of controllers) if (event.target.contains(shell)) dispose();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
